export default {
 "columns": 64,
 "image": "_PNG/MainLevBuild.png",
 "imageheight": 1312,
 "imagewidth": 1024,
 "margin": 0,
 "name": "sseworlds-1",
 "spacing": 0,
 "tilecount": 5248,
 "tiledversion": "1.11.0",
 "tileheight": 16,
 "tiles": [
  {
   "id": 8,
   "type": "ground"
  },
  {
   "id": 9,
   "type": "ground"
  },
  {
   "id": 10,
   "type": "ground"
  },
  {
   "id": 11,
   "type": "ground"
  },
  {
   "id": 12,
   "type": "ground"
  },
  {
   "id": 13,
   "type": "ground"
  },
  {
   "id": 14,
   "type": "ground"
  },
  {
   "id": 15,
   "type": "ground"
  },
  {
   "id": 34,
   "type": "ground"
  },
  {
   "id": 35,
   "type": "ground"
  },
  {
   "id": 36,
   "type": "ground"
  },
  {
   "id": 37,
   "type": "ground"
  },
  {
   "id": 38,
   "type": "ground"
  },
  {
   "id": 39,
   "type": "ground"
  },
  {
   "id": 40,
   "type": "ground"
  },
  {
   "id": 41,
   "type": "ground"
  },
  {
   "id": 52,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 8,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 53,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 1
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 57,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 12,
        "y": 5
       },
       {
        "x": 1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 58,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 59,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 1
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 64,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -4,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 65,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 66,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 67,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 68,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 69,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 70,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 71,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 72,
   "type": "ground"
  },
  {
   "id": 73,
   "type": "ground"
  },
  {
   "id": 74,
   "type": "ground"
  },
  {
   "id": 75,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 76,
   "type": "ground"
  },
  {
   "id": 77,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 78,
   "type": "ground"
  },
  {
   "id": 79,
   "type": "ground"
  },
  {
   "id": 80,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 81,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 86,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 87,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 88,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -9,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 89,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 90,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -4,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 91,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 92,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 93,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 94,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 95,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 96,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 97,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 98,
   "type": "ground"
  },
  {
   "id": 99,
   "type": "ground"
  },
  {
   "id": 100,
   "type": "ground"
  },
  {
   "id": 101,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 102,
   "type": "ground"
  },
  {
   "id": 103,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 104,
   "type": "ground"
  },
  {
   "id": 105,
   "type": "ground"
  },
  {
   "id": 106,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 107,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 112,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 113,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 114,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -9,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 115,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 116,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 15
       },
       {
        "x": 4,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 117,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 1
       },
       {
        "x": 7,
        "y": 4
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": 11,
        "y": 9
       },
       {
        "x": 11,
        "y": 12
       },
       {
        "x": 7,
        "y": 13
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 122,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 15
       },
       {
        "x": 4,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 123,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 1
       },
       {
        "x": 7,
        "y": 4
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": 11,
        "y": 9
       },
       {
        "x": 11,
        "y": 12
       },
       {
        "x": 7,
        "y": 13
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 128,
   "type": "ground"
  },
  {
   "id": 129,
   "type": "ground"
  },
  {
   "id": 130,
   "type": "ground"
  },
  {
   "id": 131,
   "type": "ground"
  },
  {
   "id": 132,
   "type": "ground"
  },
  {
   "id": 133,
   "type": "ground"
  },
  {
   "id": 134,
   "type": "ground"
  },
  {
   "id": 135,
   "type": "ground"
  },
  {
   "id": 136,
   "type": "ground"
  },
  {
   "id": 137,
   "type": "ground"
  },
  {
   "id": 142,
   "type": "ground"
  },
  {
   "id": 143,
   "type": "ground"
  },
  {
   "id": 144,
   "type": "ground"
  },
  {
   "id": 145,
   "type": "ground"
  },
  {
   "id": 146,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 149,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 150,
   "type": "ground"
  },
  {
   "id": 151,
   "type": "ground"
  },
  {
   "id": 152,
   "type": "ground"
  },
  {
   "id": 153,
   "type": "ground"
  },
  {
   "id": 154,
   "type": "ground"
  },
  {
   "id": 155,
   "type": "ground"
  },
  {
   "id": 156,
   "type": "ground"
  },
  {
   "id": 157,
   "type": "ground"
  },
  {
   "id": 158,
   "type": "ground"
  },
  {
   "id": 159,
   "type": "ground"
  },
  {
   "id": 160,
   "type": "ground"
  },
  {
   "id": 161,
   "type": "ground"
  },
  {
   "id": 162,
   "type": "ground"
  },
  {
   "id": 163,
   "type": "ground"
  },
  {
   "id": 168,
   "type": "ground"
  },
  {
   "id": 169,
   "type": "ground"
  },
  {
   "id": 170,
   "type": "ground"
  },
  {
   "id": 171,
   "type": "ground"
  },
  {
   "id": 172,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 175,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 176,
   "type": "ground"
  },
  {
   "id": 177,
   "type": "ground"
  },
  {
   "id": 178,
   "type": "ground"
  },
  {
   "id": 179,
   "type": "ground"
  },
  {
   "id": 181,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 11,
        "y": 5
       },
       {
        "x": 15,
        "y": 8
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 8,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 182,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 4
       },
       {
        "x": -3,
        "y": 8
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 187,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 11,
        "y": 5
       },
       {
        "x": 15,
        "y": 8
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 8,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 188,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 4
       },
       {
        "x": -3,
        "y": 8
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 192,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 193,
   "type": "ground"
  },
  {
   "id": 194,
   "type": "ground"
  },
  {
   "id": 195,
   "type": "ground"
  },
  {
   "id": 196,
   "type": "ground"
  },
  {
   "id": 197,
   "type": "ground"
  },
  {
   "id": 198,
   "type": "ground"
  },
  {
   "id": 199,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 200,
   "type": "ground"
  },
  {
   "id": 201,
   "type": "ground"
  },
  {
   "id": 202,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 203,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 204,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 205,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 206,
   "type": "ground"
  },
  {
   "id": 207,
   "type": "ground"
  },
  {
   "id": 208,
   "type": "ground"
  },
  {
   "id": 209,
   "type": "ground"
  },
  {
   "id": 210,
   "type": "ground"
  },
  {
   "id": 211,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 212,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 213,
   "type": "ground"
  },
  {
   "id": 214,
   "type": "ground"
  },
  {
   "id": 215,
   "type": "ground"
  },
  {
   "id": 216,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 12
       },
       {
        "x": 6,
        "y": 14
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 217,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -6,
        "y": 14
       },
       {
        "x": -15,
        "y": 12
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 218,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 219,
   "type": "ground"
  },
  {
   "id": 220,
   "type": "ground"
  },
  {
   "id": 221,
   "type": "ground"
  },
  {
   "id": 222,
   "type": "ground"
  },
  {
   "id": 223,
   "type": "ground"
  },
  {
   "id": 224,
   "type": "ground"
  },
  {
   "id": 225,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 226,
   "type": "ground"
  },
  {
   "id": 227,
   "type": "ground"
  },
  {
   "id": 228,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 229,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 230,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 231,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 232,
   "type": "ground"
  },
  {
   "id": 233,
   "type": "ground"
  },
  {
   "id": 234,
   "type": "ground"
  },
  {
   "id": 235,
   "type": "ground"
  },
  {
   "id": 236,
   "type": "ground"
  },
  {
   "id": 237,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 238,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 239,
   "type": "ground"
  },
  {
   "id": 240,
   "type": "ground"
  },
  {
   "id": 241,
   "type": "ground"
  },
  {
   "id": 242,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 12
       },
       {
        "x": 6,
        "y": 14
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 243,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -6,
        "y": 14
       },
       {
        "x": -15,
        "y": 12
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 245,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 13
       },
       {
        "x": 5,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 246,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 1
       },
       {
        "x": 8,
        "y": 4
       },
       {
        "x": 4,
        "y": 6
       },
       {
        "x": 12,
        "y": 9
       },
       {
        "x": 12,
        "y": 12
       },
       {
        "x": 9,
        "y": 13
       },
       {
        "x": 10,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 251,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 13
       },
       {
        "x": 5,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 252,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 1
       },
       {
        "x": 8,
        "y": 4
       },
       {
        "x": 4,
        "y": 6
       },
       {
        "x": 12,
        "y": 9
       },
       {
        "x": 12,
        "y": 12
       },
       {
        "x": 9,
        "y": 13
       },
       {
        "x": 10,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 256,
   "type": "ground"
  },
  {
   "id": 257,
   "type": "ground"
  },
  {
   "id": 258,
   "type": "ground"
  },
  {
   "id": 259,
   "type": "ground"
  },
  {
   "id": 260,
   "type": "ground"
  },
  {
   "id": 261,
   "type": "ground"
  },
  {
   "id": 262,
   "type": "ground"
  },
  {
   "id": 263,
   "type": "ground"
  },
  {
   "id": 264,
   "type": "ground"
  },
  {
   "id": 265,
   "type": "ground"
  },
  {
   "id": 266,
   "type": "ground"
  },
  {
   "id": 267,
   "type": "ground"
  },
  {
   "id": 268,
   "type": "ground"
  },
  {
   "id": 269,
   "type": "ground"
  },
  {
   "id": 270,
   "type": "ground"
  },
  {
   "id": 271,
   "type": "ground"
  },
  {
   "id": 272,
   "type": "ground"
  },
  {
   "id": 273,
   "type": "ground"
  },
  {
   "id": 274,
   "type": "ground"
  },
  {
   "id": 275,
   "type": "ground"
  },
  {
   "id": 276,
   "type": "ground"
  },
  {
   "id": 277,
   "type": "ground"
  },
  {
   "id": 278,
   "type": "ground"
  },
  {
   "id": 279,
   "type": "ground"
  },
  {
   "id": 282,
   "type": "ground"
  },
  {
   "id": 283,
   "type": "ground"
  },
  {
   "id": 284,
   "type": "ground"
  },
  {
   "id": 285,
   "type": "ground"
  },
  {
   "id": 286,
   "type": "ground"
  },
  {
   "id": 287,
   "type": "ground"
  },
  {
   "id": 288,
   "type": "ground"
  },
  {
   "id": 289,
   "type": "ground"
  },
  {
   "id": 290,
   "type": "ground"
  },
  {
   "id": 291,
   "type": "ground"
  },
  {
   "id": 292,
   "type": "ground"
  },
  {
   "id": 293,
   "type": "ground"
  },
  {
   "id": 294,
   "type": "ground"
  },
  {
   "id": 295,
   "type": "ground"
  },
  {
   "id": 296,
   "type": "ground"
  },
  {
   "id": 297,
   "type": "ground"
  },
  {
   "id": 298,
   "type": "ground"
  },
  {
   "id": 299,
   "type": "ground"
  },
  {
   "id": 300,
   "type": "ground"
  },
  {
   "id": 301,
   "type": "ground"
  },
  {
   "id": 302,
   "type": "ground"
  },
  {
   "id": 303,
   "type": "ground"
  },
  {
   "id": 304,
   "type": "ground"
  },
  {
   "id": 305,
   "type": "ground"
  },
  {
   "id": 310,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": -3,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 311,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": -4,
        "y": 11
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 8
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -15,
        "y": 4
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 312,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 5
       },
       {
        "x": -12,
        "y": 5
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 316,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": -3,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 317,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 8
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -15,
        "y": 4
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 320,
   "type": "ground"
  },
  {
   "id": 321,
   "type": "ground"
  },
  {
   "id": 322,
   "type": "ground"
  },
  {
   "id": 323,
   "type": "ground"
  },
  {
   "id": 324,
   "type": "ground"
  },
  {
   "id": 325,
   "type": "ground"
  },
  {
   "id": 326,
   "type": "ground"
  },
  {
   "id": 327,
   "type": "ground"
  },
  {
   "id": 328,
   "type": "ground"
  },
  {
   "id": 329,
   "type": "ground"
  },
  {
   "id": 330,
   "type": "ground"
  },
  {
   "id": 331,
   "type": "ground"
  },
  {
   "id": 332,
   "type": "ground"
  },
  {
   "id": 333,
   "type": "ground"
  },
  {
   "id": 334,
   "type": "ground"
  },
  {
   "id": 335,
   "type": "ground"
  },
  {
   "id": 336,
   "type": "ground"
  },
  {
   "id": 337,
   "type": "ground"
  },
  {
   "id": 338,
   "type": "ground"
  },
  {
   "id": 339,
   "type": "ground"
  },
  {
   "id": 340,
   "type": "ground"
  },
  {
   "id": 341,
   "type": "ground"
  },
  {
   "id": 342,
   "type": "ground"
  },
  {
   "id": 343,
   "type": "ground"
  },
  {
   "id": 344,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -9,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 345,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 346,
   "type": "ground"
  },
  {
   "id": 347,
   "type": "ground"
  },
  {
   "id": 348,
   "type": "ground"
  },
  {
   "id": 349,
   "type": "ground"
  },
  {
   "id": 350,
   "type": "ground"
  },
  {
   "id": 351,
   "type": "ground"
  },
  {
   "id": 352,
   "type": "ground"
  },
  {
   "id": 353,
   "type": "ground"
  },
  {
   "id": 354,
   "type": "ground"
  },
  {
   "id": 355,
   "type": "ground"
  },
  {
   "id": 356,
   "type": "ground"
  },
  {
   "id": 357,
   "type": "ground"
  },
  {
   "id": 358,
   "type": "ground"
  },
  {
   "id": 359,
   "type": "ground"
  },
  {
   "id": 360,
   "type": "ground"
  },
  {
   "id": 361,
   "type": "ground"
  },
  {
   "id": 362,
   "type": "ground"
  },
  {
   "id": 363,
   "type": "ground"
  },
  {
   "id": 364,
   "type": "ground"
  },
  {
   "id": 365,
   "type": "ground"
  },
  {
   "id": 366,
   "type": "ground"
  },
  {
   "id": 367,
   "type": "ground"
  },
  {
   "id": 368,
   "type": "ground"
  },
  {
   "id": 369,
   "type": "ground"
  },
  {
   "id": 370,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -9,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 371,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 374,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -7,
        "y": 13
       },
       {
        "x": -11,
        "y": 12
       },
       {
        "x": -11,
        "y": 9
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -7,
        "y": 4
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 375,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 11
       },
       {
        "x": -8,
        "y": 15
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 380,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -7,
        "y": 13
       },
       {
        "x": -11,
        "y": 12
       },
       {
        "x": -11,
        "y": 9
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -7,
        "y": 4
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 381,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 11
       },
       {
        "x": -8,
        "y": 15
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 384,
   "type": "ground"
  },
  {
   "id": 385,
   "type": "ground"
  },
  {
   "id": 386,
   "type": "ground"
  },
  {
   "id": 387,
   "type": "ground"
  },
  {
   "id": 388,
   "type": "ground"
  },
  {
   "id": 389,
   "type": "ground"
  },
  {
   "id": 390,
   "type": "ground"
  },
  {
   "id": 391,
   "type": "ground"
  },
  {
   "id": 408,
   "type": "ground"
  },
  {
   "id": 409,
   "type": "ground"
  },
  {
   "id": 410,
   "type": "ground"
  },
  {
   "id": 411,
   "type": "ground"
  },
  {
   "id": 412,
   "type": "ground"
  },
  {
   "id": 413,
   "type": "ground"
  },
  {
   "id": 414,
   "type": "ground"
  },
  {
   "id": 415,
   "type": "ground"
  },
  {
   "id": 416,
   "type": "ground"
  },
  {
   "id": 417,
   "type": "ground"
  },
  {
   "id": 434,
   "type": "ground"
  },
  {
   "id": 435,
   "type": "ground"
  },
  {
   "id": 437,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 8
       },
       {
        "x": -1,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 438,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 8
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -15,
        "y": 4
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 443,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 8
       },
       {
        "x": -1,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 444,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 8
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -15,
        "y": 4
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 448,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 449,
   "type": "ground"
  },
  {
   "id": 450,
   "type": "ground"
  },
  {
   "id": 451,
   "type": "ground"
  },
  {
   "id": 452,
   "type": "ground"
  },
  {
   "id": 453,
   "type": "ground"
  },
  {
   "id": 454,
   "type": "ground"
  },
  {
   "id": 455,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 456,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -10,
        "y": 3
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 457,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -3,
        "y": -6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 458,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -2
       },
       {
        "x": -1,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 459,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": -1
       },
       {
        "x": 10,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 460,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -15,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 461,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 470,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 471,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -1,
        "y": -6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 472,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 12
       },
       {
        "x": 6,
        "y": 14
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 473,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -6,
        "y": 14
       },
       {
        "x": -15,
        "y": 12
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 474,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 475,
   "type": "ground"
  },
  {
   "id": 476,
   "type": "ground"
  },
  {
   "id": 477,
   "type": "ground"
  },
  {
   "id": 478,
   "type": "ground"
  },
  {
   "id": 479,
   "type": "ground"
  },
  {
   "id": 480,
   "type": "ground"
  },
  {
   "id": 481,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 482,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -10,
        "y": 3
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 483,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -3,
        "y": -6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 484,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -2
       },
       {
        "x": -1,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 485,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": -1
       },
       {
        "x": 10,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 486,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -15,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 487,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 496,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 497,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -1,
        "y": -6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 498,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 12
       },
       {
        "x": 6,
        "y": 14
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 499,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -6,
        "y": 14
       },
       {
        "x": -15,
        "y": 12
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 501,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -9,
        "y": 13
       },
       {
        "x": -12,
        "y": 12
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -4,
        "y": 6
       },
       {
        "x": -8,
        "y": 4
       },
       {
        "x": -8,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 502,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 13
       },
       {
        "x": -7,
        "y": 13
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 507,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -9,
        "y": 13
       },
       {
        "x": -12,
        "y": 12
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -4,
        "y": 6
       },
       {
        "x": -8,
        "y": 4
       },
       {
        "x": -8,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 508,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 13
       },
       {
        "x": -7,
        "y": 13
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 512,
   "type": "ground"
  },
  {
   "id": 513,
   "type": "ground"
  },
  {
   "id": 514,
   "type": "ground"
  },
  {
   "id": 515,
   "type": "ground"
  },
  {
   "id": 516,
   "type": "ground"
  },
  {
   "id": 517,
   "type": "ground"
  },
  {
   "id": 518,
   "type": "ground"
  },
  {
   "id": 519,
   "type": "ground"
  },
  {
   "id": 520,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -16
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 521,
   "type": "ground"
  },
  {
   "id": 522,
   "type": "ground"
  },
  {
   "id": 523,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 524,
   "type": "ground"
  },
  {
   "id": 525,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 526,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 4
       },
       {
        "x": 6,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 533,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -6,
        "y": 7
       },
       {
        "x": -1,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 534,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 535,
   "type": "ground"
  },
  {
   "id": 538,
   "type": "ground"
  },
  {
   "id": 539,
   "type": "ground"
  },
  {
   "id": 540,
   "type": "ground"
  },
  {
   "id": 541,
   "type": "ground"
  },
  {
   "id": 542,
   "type": "ground"
  },
  {
   "id": 543,
   "type": "ground"
  },
  {
   "id": 544,
   "type": "ground"
  },
  {
   "id": 545,
   "type": "ground"
  },
  {
   "id": 546,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -16
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 547,
   "type": "ground"
  },
  {
   "id": 548,
   "type": "ground"
  },
  {
   "id": 549,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 550,
   "type": "ground"
  },
  {
   "id": 551,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 552,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 4
       },
       {
        "x": 6,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 559,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -6,
        "y": 7
       },
       {
        "x": -1,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 560,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 561,
   "type": "ground"
  },
  {
   "id": 565,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 11,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 566,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 12,
        "y": 11
       },
       {
        "x": 1,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 567,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 568,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 569,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -13,
        "y": 11
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 570,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 571,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 11,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 572,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 11,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 574,
   "type": "ground"
  },
  {
   "id": 575,
   "type": "ground"
  },
  {
   "id": 576,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -14,
        "y": 9
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 577,
   "type": "ground"
  },
  {
   "id": 578,
   "type": "ground"
  },
  {
   "id": 579,
   "type": "ground"
  },
  {
   "id": 580,
   "type": "ground"
  },
  {
   "id": 581,
   "type": "ground"
  },
  {
   "id": 582,
   "type": "ground"
  },
  {
   "id": 583,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 14,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 584,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -14
       },
       {
        "x": 16,
        "y": -14
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 585,
   "type": "ground"
  },
  {
   "id": 586,
   "type": "ground"
  },
  {
   "id": 587,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 14
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 588,
   "type": "ground"
  },
  {
   "id": 589,
   "type": "ground"
  },
  {
   "id": 590,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 591,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 596,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -8,
        "y": 7
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 597,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 598,
   "type": "ground"
  },
  {
   "id": 599,
   "type": "ground"
  },
  {
   "id": 600,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -15,
        "y": 4
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 601,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -4
       },
       {
        "x": -7,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 602,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -14,
        "y": 9
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 603,
   "type": "ground"
  },
  {
   "id": 604,
   "type": "ground"
  },
  {
   "id": 605,
   "type": "ground"
  },
  {
   "id": 606,
   "type": "ground"
  },
  {
   "id": 607,
   "type": "ground"
  },
  {
   "id": 608,
   "type": "ground"
  },
  {
   "id": 609,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 14,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 610,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -14
       },
       {
        "x": 16,
        "y": -14
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 611,
   "type": "ground"
  },
  {
   "id": 612,
   "type": "ground"
  },
  {
   "id": 613,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 14
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 614,
   "type": "ground"
  },
  {
   "id": 615,
   "type": "ground"
  },
  {
   "id": 616,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 617,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 622,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -8,
        "y": 7
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 623,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 624,
   "type": "ground"
  },
  {
   "id": 625,
   "type": "ground"
  },
  {
   "id": 626,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -15,
        "y": 4
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 627,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -4
       },
       {
        "x": -7,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 630,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 631,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -6,
        "y": 4
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 632,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 4,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 633,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 638,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 4
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 639,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 4,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 640,
   "type": "ground"
  },
  {
   "id": 641,
   "type": "ground"
  },
  {
   "id": 642,
   "type": "ground"
  },
  {
   "id": 643,
   "type": "ground"
  },
  {
   "id": 644,
   "type": "ground"
  },
  {
   "id": 645,
   "type": "ground"
  },
  {
   "id": 646,
   "type": "ground"
  },
  {
   "id": 647,
   "type": "ground"
  },
  {
   "id": 648,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 649,
   "type": "ground"
  },
  {
   "id": 650,
   "type": "ground"
  },
  {
   "id": 651,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 652,
   "type": "ground"
  },
  {
   "id": 653,
   "type": "ground"
  },
  {
   "id": 654,
   "type": "ground"
  },
  {
   "id": 655,
   "type": "ground"
  },
  {
   "id": 656,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 659,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 660,
   "type": "ground"
  },
  {
   "id": 661,
   "type": "ground"
  },
  {
   "id": 662,
   "type": "ground"
  },
  {
   "id": 663,
   "type": "ground"
  },
  {
   "id": 664,
   "type": "ground"
  },
  {
   "id": 665,
   "type": "ground"
  },
  {
   "id": 666,
   "type": "ground"
  },
  {
   "id": 667,
   "type": "ground"
  },
  {
   "id": 668,
   "type": "ground"
  },
  {
   "id": 669,
   "type": "ground"
  },
  {
   "id": 670,
   "type": "ground"
  },
  {
   "id": 671,
   "type": "ground"
  },
  {
   "id": 672,
   "type": "ground"
  },
  {
   "id": 673,
   "type": "ground"
  },
  {
   "id": 674,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 675,
   "type": "ground"
  },
  {
   "id": 676,
   "type": "ground"
  },
  {
   "id": 677,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 678,
   "type": "ground"
  },
  {
   "id": 679,
   "type": "ground"
  },
  {
   "id": 680,
   "type": "ground"
  },
  {
   "id": 681,
   "type": "ground"
  },
  {
   "id": 682,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 685,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 686,
   "type": "ground"
  },
  {
   "id": 687,
   "type": "ground"
  },
  {
   "id": 688,
   "type": "ground"
  },
  {
   "id": 689,
   "type": "ground"
  },
  {
   "id": 690,
   "type": "ground"
  },
  {
   "id": 691,
   "type": "ground"
  },
  {
   "id": 694,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 12,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 695,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 696,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 5,
      "x": 11,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 697,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 702,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 8,
      "x": 2,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 703,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 8,
      "x": 7,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 704,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 12
       },
       {
        "x": 5,
        "y": 14
       },
       {
        "x": -1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 705,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 706,
   "type": "ground"
  },
  {
   "id": 707,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 708,
   "type": "ground"
  },
  {
   "id": 709,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 710,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 711,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -5,
        "y": 14
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 712,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 5,
        "y": 7
       },
       {
        "x": 3,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 713,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 0,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 714,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 16,
        "y": -12
       },
       {
        "x": 0,
        "y": -12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 715,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -5,
        "y": 7
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 716,
   "type": "ground"
  },
  {
   "id": 717,
   "type": "ground"
  },
  {
   "id": 718,
   "type": "ground"
  },
  {
   "id": 719,
   "type": "ground"
  },
  {
   "id": 720,
   "type": "ground"
  },
  {
   "id": 721,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 722,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 723,
   "type": "ground"
  },
  {
   "id": 724,
   "type": "ground"
  },
  {
   "id": 725,
   "type": "ground"
  },
  {
   "id": 726,
   "type": "ground"
  },
  {
   "id": 727,
   "type": "ground"
  },
  {
   "id": 728,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 729,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 730,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 12
       },
       {
        "x": 5,
        "y": 14
       },
       {
        "x": -1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 731,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 732,
   "type": "ground"
  },
  {
   "id": 733,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 734,
   "type": "ground"
  },
  {
   "id": 735,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 736,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 737,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -5,
        "y": 14
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 738,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 5,
        "y": 7
       },
       {
        "x": 3,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 739,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 0,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 740,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 16,
        "y": -12
       },
       {
        "x": 0,
        "y": -12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 741,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -5,
        "y": 7
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 742,
   "type": "ground"
  },
  {
   "id": 743,
   "type": "ground"
  },
  {
   "id": 744,
   "type": "ground"
  },
  {
   "id": 745,
   "type": "ground"
  },
  {
   "id": 746,
   "type": "ground"
  },
  {
   "id": 747,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 748,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 749,
   "type": "ground"
  },
  {
   "id": 750,
   "type": "ground"
  },
  {
   "id": 751,
   "type": "ground"
  },
  {
   "id": 752,
   "type": "ground"
  },
  {
   "id": 753,
   "type": "ground"
  },
  {
   "id": 754,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 755,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 758,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 12,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 759,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 760,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 5,
      "x": 11,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 761,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 766,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 8,
      "x": 2,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 767,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 8,
      "x": 7,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 776,
   "type": "ground"
  },
  {
   "id": 777,
   "type": "ground"
  },
  {
   "id": 780,
   "type": "ground"
  },
  {
   "id": 781,
   "type": "ground"
  },
  {
   "id": 782,
   "type": "ground"
  },
  {
   "id": 783,
   "type": "ground"
  },
  {
   "id": 784,
   "type": "ground"
  },
  {
   "id": 785,
   "type": "ground"
  },
  {
   "id": 786,
   "type": "ground"
  },
  {
   "id": 787,
   "type": "ground"
  },
  {
   "id": 788,
   "type": "ground"
  },
  {
   "id": 789,
   "type": "ground"
  },
  {
   "id": 790,
   "type": "ground"
  },
  {
   "id": 791,
   "type": "ground"
  },
  {
   "id": 802,
   "type": "ground"
  },
  {
   "id": 803,
   "type": "ground"
  },
  {
   "id": 806,
   "type": "ground"
  },
  {
   "id": 807,
   "type": "ground"
  },
  {
   "id": 808,
   "type": "ground"
  },
  {
   "id": 809,
   "type": "ground"
  },
  {
   "id": 810,
   "type": "ground"
  },
  {
   "id": 811,
   "type": "ground"
  },
  {
   "id": 812,
   "type": "ground"
  },
  {
   "id": 813,
   "type": "ground"
  },
  {
   "id": 814,
   "type": "ground"
  },
  {
   "id": 815,
   "type": "ground"
  },
  {
   "id": 816,
   "type": "ground"
  },
  {
   "id": 817,
   "type": "ground"
  },
  {
   "id": 820,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -9,
        "y": 1
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -13,
        "y": 5
       },
       {
        "x": -13,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 821,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 2
       },
       {
        "x": -7,
        "y": 6
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -16,
        "y": -2
       },
       {
        "x": -10,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 822,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -9,
        "y": 6
       },
       {
        "x": -9,
        "y": 9
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 823,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 3
       },
       {
        "x": -7,
        "y": 8
       },
       {
        "x": -10,
        "y": 8
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -16,
        "y": -1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 826,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -9,
        "y": 4
       },
       {
        "x": -9,
        "y": 9
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -13,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -13,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 827,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -7,
        "y": 4
       },
       {
        "x": -7,
        "y": 9
       },
       {
        "x": -10,
        "y": 9
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 828,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -9,
        "y": 4
       },
       {
        "x": -9,
        "y": 9
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -13,
        "y": 4
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -13,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 829,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -7,
        "y": 4
       },
       {
        "x": -7,
        "y": 9
       },
       {
        "x": -10,
        "y": 9
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 830,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -9,
        "y": 4
       },
       {
        "x": -9,
        "y": 9
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -13,
        "y": 4
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -13,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 831,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 3
       },
       {
        "x": -7,
        "y": 8
       },
       {
        "x": -10,
        "y": 8
       },
       {
        "x": -10,
        "y": 3
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -16,
        "y": -1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 840,
   "type": "ground"
  },
  {
   "id": 841,
   "type": "ground"
  },
  {
   "id": 844,
   "type": "ground"
  },
  {
   "id": 845,
   "type": "ground"
  },
  {
   "id": 846,
   "type": "ground"
  },
  {
   "id": 847,
   "type": "ground"
  },
  {
   "id": 848,
   "type": "ground"
  },
  {
   "id": 849,
   "type": "ground"
  },
  {
   "id": 850,
   "type": "ground"
  },
  {
   "id": 851,
   "type": "ground"
  },
  {
   "id": 852,
   "type": "ground"
  },
  {
   "id": 853,
   "type": "ground"
  },
  {
   "id": 854,
   "type": "ground"
  },
  {
   "id": 855,
   "type": "ground"
  },
  {
   "id": 856,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -9,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 857,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 866,
   "type": "ground"
  },
  {
   "id": 867,
   "type": "ground"
  },
  {
   "id": 870,
   "type": "ground"
  },
  {
   "id": 871,
   "type": "ground"
  },
  {
   "id": 872,
   "type": "ground"
  },
  {
   "id": 873,
   "type": "ground"
  },
  {
   "id": 874,
   "type": "ground"
  },
  {
   "id": 875,
   "type": "ground"
  },
  {
   "id": 876,
   "type": "ground"
  },
  {
   "id": 877,
   "type": "ground"
  },
  {
   "id": 878,
   "type": "ground"
  },
  {
   "id": 879,
   "type": "ground"
  },
  {
   "id": 880,
   "type": "ground"
  },
  {
   "id": 881,
   "type": "ground"
  },
  {
   "id": 882,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -9,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 883,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 884,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 3,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 885,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 6,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 886,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 3,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 887,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 6,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 890,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 3,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 891,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 6,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 892,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 3,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 893,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 6,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 894,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 4,
      "x": 3,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 895,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 6,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 905,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 906,
   "type": "ground"
  },
  {
   "id": 907,
   "type": "ground"
  },
  {
   "id": 908,
   "type": "ground"
  },
  {
   "id": 909,
   "type": "ground"
  },
  {
   "id": 910,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 920,
   "type": "ground"
  },
  {
   "id": 921,
   "type": "ground"
  },
  {
   "id": 931,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 932,
   "type": "ground"
  },
  {
   "id": 933,
   "type": "ground"
  },
  {
   "id": 934,
   "type": "ground"
  },
  {
   "id": 935,
   "type": "ground"
  },
  {
   "id": 936,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 946,
   "type": "ground"
  },
  {
   "id": 947,
   "type": "ground"
  },
  {
   "id": 948,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -4,
        "y": 8
       },
       {
        "x": -11,
        "y": 8
       },
       {
        "x": -16,
        "y": 5
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -11,
        "y": -1
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": -5,
        "y": -6
       },
       {
        "x": -4,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 949,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 7,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 8
     }
    ]
   }
  },
  {
   "id": 950,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 951,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 16,
        "y": 14
       },
       {
        "x": 0,
        "y": 14
       }
      ]
     }
    ]
   }
  },
  {
   "id": 952,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 7,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 8
     }
    ]
   }
  },
  {
   "id": 953,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -5,
        "y": 7
       },
       {
        "x": -16,
        "y": 6
       },
       {
        "x": -16,
        "y": -1
       },
       {
        "x": -12,
        "y": -2
       },
       {
        "x": -11,
        "y": -7
       },
       {
        "x": -6,
        "y": -7
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 954,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -5,
        "y": 8
       },
       {
        "x": -12,
        "y": 8
       },
       {
        "x": -16,
        "y": 5
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -10,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 955,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 3
       },
       {
        "x": 12,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 956,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 13
       },
       {
        "x": -11,
        "y": 13
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -3,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 957,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 13
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 0,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 958,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 959,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 6
       },
       {
        "x": -15,
        "y": 6
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -11,
        "y": -5
       },
       {
        "x": -6,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 960,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 961,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 962,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 963,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -4,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 964,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 965,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 966,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 967,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 968,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 969,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 970,
   "type": "ground"
  },
  {
   "id": 971,
   "type": "ground"
  },
  {
   "id": 972,
   "type": "ground"
  },
  {
   "id": 973,
   "type": "ground"
  },
  {
   "id": 974,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 975,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 976,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 977,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": -7,
        "y": -3
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 978,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 979,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 980,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 981,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 982,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 983,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 984,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 985,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 986,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 987,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 988,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 989,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -4,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 990,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 991,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 992,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 993,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -9,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 994,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 995,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 996,
   "type": "ground"
  },
  {
   "id": 997,
   "type": "ground"
  },
  {
   "id": 998,
   "type": "ground"
  },
  {
   "id": 999,
   "type": "ground"
  },
  {
   "id": 1000,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1001,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1002,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1003,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": -7,
        "y": -3
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1004,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1005,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1006,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1007,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1008,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1009,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1010,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1011,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1012,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 3
       },
       {
        "x": 11,
        "y": 4
       },
       {
        "x": 11,
        "y": 11
       },
       {
        "x": 7,
        "y": 11
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -4,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1013,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 7,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 4
     }
    ]
   }
  },
  {
   "id": 1014,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 1015,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 1016,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 7,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 4
     }
    ]
   }
  },
  {
   "id": 1017,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 3
       },
       {
        "x": 11,
        "y": 5
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -4,
        "y": 11
       },
       {
        "x": -4,
        "y": 4
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1018,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 8,
        "y": 4
       },
       {
        "x": 12,
        "y": 7
       },
       {
        "x": 12,
        "y": 13
       },
       {
        "x": 7,
        "y": 13
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       },
       {
        "x": 1,
        "y": 11
       },
       {
        "x": -3,
        "y": 8
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1019,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 4
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1020,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 0
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -5,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1021,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 6
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1022,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -6,
        "y": 7
       },
       {
        "x": -7,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1023,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 3
       },
       {
        "x": 11,
        "y": 5
       },
       {
        "x": 7,
        "y": 10
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -4,
        "y": 11
       },
       {
        "x": -4,
        "y": 5
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1024,
   "type": "ground"
  },
  {
   "id": 1025,
   "type": "ground"
  },
  {
   "id": 1026,
   "type": "ground"
  },
  {
   "id": 1027,
   "type": "ground"
  },
  {
   "id": 1028,
   "type": "ground"
  },
  {
   "id": 1029,
   "type": "ground"
  },
  {
   "id": 1030,
   "type": "ground"
  },
  {
   "id": 1031,
   "type": "ground"
  },
  {
   "id": 1032,
   "type": "ground"
  },
  {
   "id": 1033,
   "type": "ground"
  },
  {
   "id": 1034,
   "type": "ground"
  },
  {
   "id": 1035,
   "type": "ground"
  },
  {
   "id": 1036,
   "type": "ground"
  },
  {
   "id": 1037,
   "type": "ground"
  },
  {
   "id": 1038,
   "type": "ground"
  },
  {
   "id": 1039,
   "type": "ground"
  },
  {
   "id": 1040,
   "type": "ground"
  },
  {
   "id": 1041,
   "type": "ground"
  },
  {
   "id": 1042,
   "type": "ground"
  },
  {
   "id": 1043,
   "type": "ground"
  },
  {
   "id": 1044,
   "type": "ground"
  },
  {
   "id": 1045,
   "type": "ground"
  },
  {
   "id": 1046,
   "type": "ground"
  },
  {
   "id": 1047,
   "type": "ground"
  },
  {
   "id": 1048,
   "type": "ground"
  },
  {
   "id": 1049,
   "type": "ground"
  },
  {
   "id": 1050,
   "type": "ground"
  },
  {
   "id": 1051,
   "type": "ground"
  },
  {
   "id": 1052,
   "type": "ground"
  },
  {
   "id": 1053,
   "type": "ground"
  },
  {
   "id": 1054,
   "type": "ground"
  },
  {
   "id": 1055,
   "type": "ground"
  },
  {
   "id": 1056,
   "type": "ground"
  },
  {
   "id": 1057,
   "type": "ground"
  },
  {
   "id": 1058,
   "type": "ground"
  },
  {
   "id": 1059,
   "type": "ground"
  },
  {
   "id": 1060,
   "type": "ground"
  },
  {
   "id": 1061,
   "type": "ground"
  },
  {
   "id": 1062,
   "type": "ground"
  },
  {
   "id": 1063,
   "type": "ground"
  },
  {
   "id": 1064,
   "type": "ground"
  },
  {
   "id": 1065,
   "type": "ground"
  },
  {
   "id": 1066,
   "type": "ground"
  },
  {
   "id": 1067,
   "type": "ground"
  },
  {
   "id": 1068,
   "type": "ground"
  },
  {
   "id": 1069,
   "type": "ground"
  },
  {
   "id": 1070,
   "type": "ground"
  },
  {
   "id": 1071,
   "type": "ground"
  },
  {
   "id": 1072,
   "type": "ground"
  },
  {
   "id": 1073,
   "type": "ground"
  },
  {
   "id": 1074,
   "type": "ground"
  },
  {
   "id": 1075,
   "type": "ground"
  },
  {
   "id": 1088,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1089,
   "type": "ground"
  },
  {
   "id": 1090,
   "type": "ground"
  },
  {
   "id": 1091,
   "type": "ground"
  },
  {
   "id": 1092,
   "type": "ground"
  },
  {
   "id": 1093,
   "type": "ground"
  },
  {
   "id": 1094,
   "type": "ground"
  },
  {
   "id": 1095,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1096,
   "type": "ground"
  },
  {
   "id": 1097,
   "type": "ground"
  },
  {
   "id": 1098,
   "type": "ground"
  },
  {
   "id": 1099,
   "type": "ground"
  },
  {
   "id": 1100,
   "type": "ground"
  },
  {
   "id": 1101,
   "type": "ground"
  },
  {
   "id": 1102,
   "type": "ground"
  },
  {
   "id": 1103,
   "type": "ground"
  },
  {
   "id": 1104,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 12
       },
       {
        "x": 6,
        "y": 14
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1105,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1106,
   "type": "ground"
  },
  {
   "id": 1107,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1108,
   "type": "ground"
  },
  {
   "id": 1109,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1110,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1111,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -6,
        "y": 14
       },
       {
        "x": -15,
        "y": 12
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1112,
   "type": "ground"
  },
  {
   "id": 1113,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1114,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -13,
        "y": 9
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1115,
   "type": "ground"
  },
  {
   "id": 1116,
   "type": "ground"
  },
  {
   "id": 1117,
   "type": "ground"
  },
  {
   "id": 1118,
   "type": "ground"
  },
  {
   "id": 1119,
   "type": "ground"
  },
  {
   "id": 1120,
   "type": "ground"
  },
  {
   "id": 1121,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 13,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1122,
   "type": "ground"
  },
  {
   "id": 1123,
   "type": "ground"
  },
  {
   "id": 1124,
   "type": "ground"
  },
  {
   "id": 1125,
   "type": "ground"
  },
  {
   "id": 1126,
   "type": "ground"
  },
  {
   "id": 1127,
   "type": "ground"
  },
  {
   "id": 1128,
   "type": "ground"
  },
  {
   "id": 1129,
   "type": "ground"
  },
  {
   "id": 1130,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 12
       },
       {
        "x": 6,
        "y": 14
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1131,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1132,
   "type": "ground"
  },
  {
   "id": 1133,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1134,
   "type": "ground"
  },
  {
   "id": 1135,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1136,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1137,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -6,
        "y": 14
       },
       {
        "x": -15,
        "y": 12
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1138,
   "type": "ground"
  },
  {
   "id": 1139,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1144,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 10
       },
       {
        "x": -13,
        "y": 10
       },
       {
        "x": -11,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1145,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -13,
        "y": -9
       },
       {
        "x": -7,
        "y": -10
       },
       {
        "x": -8,
        "y": -12
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1160,
   "type": "ground"
  },
  {
   "id": 1161,
   "type": "ground"
  },
  {
   "id": 1166,
   "type": "ground"
  },
  {
   "id": 1167,
   "type": "ground"
  },
  {
   "id": 1176,
   "type": "ground"
  },
  {
   "id": 1177,
   "type": "ground"
  },
  {
   "id": 1186,
   "type": "ground"
  },
  {
   "id": 1187,
   "type": "ground"
  },
  {
   "id": 1192,
   "type": "ground"
  },
  {
   "id": 1193,
   "type": "ground"
  },
  {
   "id": 1202,
   "type": "ground"
  },
  {
   "id": 1203,
   "type": "ground"
  },
  {
   "id": 1208,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 4
       },
       {
        "x": -6,
        "y": 5
       },
       {
        "x": -8,
        "y": 14
       },
       {
        "x": -8,
        "y": 5
       },
       {
        "x": -13,
        "y": 4
       },
       {
        "x": -13,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1209,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": -10,
        "y": 12
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1216,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1217,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1218,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1219,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -4,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1220,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1221,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1222,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1223,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -10,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1224,
   "type": "ground"
  },
  {
   "id": 1225,
   "type": "ground"
  },
  {
   "id": 1230,
   "type": "ground"
  },
  {
   "id": 1231,
   "type": "ground"
  },
  {
   "id": 1240,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1241,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 14,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1242,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1243,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1244,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1245,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -4,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1246,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1247,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1248,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1249,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -10,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1250,
   "type": "ground"
  },
  {
   "id": 1251,
   "type": "ground"
  },
  {
   "id": 1256,
   "type": "ground"
  },
  {
   "id": 1257,
   "type": "ground"
  },
  {
   "id": 1266,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1267,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 14,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1269,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 4
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -7,
        "y": 7
       },
       {
        "x": -8,
        "y": 9
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -10,
        "y": 13
       },
       {
        "x": -8,
        "y": 7
       },
       {
        "x": -11,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1270,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -13,
        "y": 2
       },
       {
        "x": -9,
        "y": 6
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -13,
        "y": -5
       },
       {
        "x": -9,
        "y": -5
       },
       {
        "x": -13,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1275,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": -2
       },
       {
        "x": -1,
        "y": -6
       },
       {
        "x": -14,
        "y": -8
       },
       {
        "x": -1,
        "y": -11
       },
       {
        "x": -5,
        "y": -13
       },
       {
        "x": -1,
        "y": -13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1276,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 2
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 10,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": 8,
        "y": 9
       },
       {
        "x": 7,
        "y": 7
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": 7,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1280,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": -1,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1281,
   "type": "ground"
  },
  {
   "id": 1282,
   "type": "ground"
  },
  {
   "id": 1283,
   "type": "ground"
  },
  {
   "id": 1284,
   "type": "ground"
  },
  {
   "id": 1285,
   "type": "ground"
  },
  {
   "id": 1286,
   "type": "ground"
  },
  {
   "id": 1287,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1289,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1290,
   "type": "ground"
  },
  {
   "id": 1291,
   "type": "ground"
  },
  {
   "id": 1292,
   "type": "ground"
  },
  {
   "id": 1293,
   "type": "ground"
  },
  {
   "id": 1294,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1304,
   "type": "ground"
  },
  {
   "id": 1305,
   "type": "ground"
  },
  {
   "id": 1306,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": -1,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1307,
   "type": "ground"
  },
  {
   "id": 1308,
   "type": "ground"
  },
  {
   "id": 1309,
   "type": "ground"
  },
  {
   "id": 1310,
   "type": "ground"
  },
  {
   "id": 1311,
   "type": "ground"
  },
  {
   "id": 1312,
   "type": "ground"
  },
  {
   "id": 1313,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1315,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1316,
   "type": "ground"
  },
  {
   "id": 1317,
   "type": "ground"
  },
  {
   "id": 1318,
   "type": "ground"
  },
  {
   "id": 1319,
   "type": "ground"
  },
  {
   "id": 1320,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1330,
   "type": "ground"
  },
  {
   "id": 1331,
   "type": "ground"
  },
  {
   "id": 1333,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 2
       },
       {
        "x": -1,
        "y": 5
       },
       {
        "x": 9,
        "y": 6
       },
       {
        "x": -1,
        "y": 8
       },
       {
        "x": 9,
        "y": 12
       },
       {
        "x": 9,
        "y": 13
       },
       {
        "x": -1,
        "y": 13
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": -3,
        "y": 8
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1334,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -9,
        "y": 3
       },
       {
        "x": -5,
        "y": 10
       },
       {
        "x": -12,
        "y": 10
       },
       {
        "x": -12,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1339,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 15,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       },
       {
        "x": -3,
        "y": -7
       },
       {
        "x": -12,
        "y": -10
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1340,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 5
       },
       {
        "x": 2,
        "y": 7
       },
       {
        "x": 2,
        "y": 10
       },
       {
        "x": -1,
        "y": 11
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -10,
        "y": 15
       },
       {
        "x": -10,
        "y": 12
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -10,
        "y": 9
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -10,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1345,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": -3
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1346,
   "type": "ground"
  },
  {
   "id": 1347,
   "type": "ground"
  },
  {
   "id": 1348,
   "type": "ground"
  },
  {
   "id": 1349,
   "type": "ground"
  },
  {
   "id": 1350,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1352,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1353,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1354,
   "type": "ground"
  },
  {
   "id": 1355,
   "type": "ground"
  },
  {
   "id": 1356,
   "type": "ground"
  },
  {
   "id": 1357,
   "type": "ground"
  },
  {
   "id": 1358,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1359,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1368,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -14,
        "y": 9
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1369,
   "type": "ground"
  },
  {
   "id": 1371,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": -3
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1372,
   "type": "ground"
  },
  {
   "id": 1373,
   "type": "ground"
  },
  {
   "id": 1374,
   "type": "ground"
  },
  {
   "id": 1375,
   "type": "ground"
  },
  {
   "id": 1376,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1378,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1379,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1380,
   "type": "ground"
  },
  {
   "id": 1381,
   "type": "ground"
  },
  {
   "id": 1382,
   "type": "ground"
  },
  {
   "id": 1383,
   "type": "ground"
  },
  {
   "id": 1384,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1385,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1394,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -14,
        "y": 9
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1395,
   "type": "ground"
  },
  {
   "id": 1408,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 3,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1409,
   "type": "ground"
  },
  {
   "id": 1410,
   "type": "ground"
  },
  {
   "id": 1411,
   "type": "ground"
  },
  {
   "id": 1412,
   "type": "ground"
  },
  {
   "id": 1413,
   "type": "ground"
  },
  {
   "id": 1414,
   "type": "ground"
  },
  {
   "id": 1415,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 11
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1416,
   "type": "ground"
  },
  {
   "id": 1417,
   "type": "ground"
  },
  {
   "id": 1418,
   "type": "ground"
  },
  {
   "id": 1419,
   "type": "ground"
  },
  {
   "id": 1420,
   "type": "ground"
  },
  {
   "id": 1421,
   "type": "ground"
  },
  {
   "id": 1422,
   "type": "ground"
  },
  {
   "id": 1423,
   "type": "ground"
  },
  {
   "id": 1432,
   "type": "ground"
  },
  {
   "id": 1433,
   "type": "ground"
  },
  {
   "id": 1434,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 3,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1435,
   "type": "ground"
  },
  {
   "id": 1436,
   "type": "ground"
  },
  {
   "id": 1437,
   "type": "ground"
  },
  {
   "id": 1438,
   "type": "ground"
  },
  {
   "id": 1439,
   "type": "ground"
  },
  {
   "id": 1440,
   "type": "ground"
  },
  {
   "id": 1441,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 11
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1442,
   "type": "ground"
  },
  {
   "id": 1443,
   "type": "ground"
  },
  {
   "id": 1444,
   "type": "ground"
  },
  {
   "id": 1445,
   "type": "ground"
  },
  {
   "id": 1446,
   "type": "ground"
  },
  {
   "id": 1447,
   "type": "ground"
  },
  {
   "id": 1448,
   "type": "ground"
  },
  {
   "id": 1449,
   "type": "ground"
  },
  {
   "id": 1458,
   "type": "ground"
  },
  {
   "id": 1459,
   "type": "ground"
  },
  {
   "id": 1461,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 4
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -7,
        "y": 7
       },
       {
        "x": -8,
        "y": 9
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -10,
        "y": 13
       },
       {
        "x": -8,
        "y": 7
       },
       {
        "x": -11,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1462,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -13,
        "y": 2
       },
       {
        "x": -9,
        "y": 6
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -13,
        "y": -5
       },
       {
        "x": -9,
        "y": -5
       },
       {
        "x": -13,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1464,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 6
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1465,
   "type": "spikes"
  },
  {
   "id": 1467,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 15,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": -2
       },
       {
        "x": -1,
        "y": -6
       },
       {
        "x": -14,
        "y": -8
       },
       {
        "x": -1,
        "y": -11
       },
       {
        "x": -5,
        "y": -13
       },
       {
        "x": -1,
        "y": -13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1468,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 2
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 10,
        "y": 13
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": 8,
        "y": 9
       },
       {
        "x": 7,
        "y": 7
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": 7,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1473,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 14
       },
       {
        "x": 16,
        "y": -2
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1474,
   "type": "ground"
  },
  {
   "id": 1475,
   "type": "ground"
  },
  {
   "id": 1476,
   "type": "ground"
  },
  {
   "id": 1477,
   "type": "ground"
  },
  {
   "id": 1478,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -14
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1480,
   "type": "ground"
  },
  {
   "id": 1481,
   "type": "ground"
  },
  {
   "id": 1482,
   "type": "ground"
  },
  {
   "id": 1483,
   "type": "ground"
  },
  {
   "id": 1484,
   "type": "ground"
  },
  {
   "id": 1485,
   "type": "ground"
  },
  {
   "id": 1486,
   "type": "ground"
  },
  {
   "id": 1487,
   "type": "ground"
  },
  {
   "id": 1488,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -14,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1489,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": -7,
        "y": -3
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1490,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1491,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1492,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1493,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1494,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1495,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1496,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 12
       },
       {
        "x": 5,
        "y": 14
       },
       {
        "x": -1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1497,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -5,
        "y": 14
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1499,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 14
       },
       {
        "x": 16,
        "y": -2
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1500,
   "type": "ground"
  },
  {
   "id": 1501,
   "type": "ground"
  },
  {
   "id": 1502,
   "type": "ground"
  },
  {
   "id": 1503,
   "type": "ground"
  },
  {
   "id": 1504,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -14
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1506,
   "type": "ground"
  },
  {
   "id": 1507,
   "type": "ground"
  },
  {
   "id": 1508,
   "type": "ground"
  },
  {
   "id": 1509,
   "type": "ground"
  },
  {
   "id": 1510,
   "type": "ground"
  },
  {
   "id": 1511,
   "type": "ground"
  },
  {
   "id": 1512,
   "type": "ground"
  },
  {
   "id": 1513,
   "type": "ground"
  },
  {
   "id": 1514,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -14,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1515,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": -7,
        "y": -3
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1516,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1517,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1518,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1519,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1520,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1521,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1522,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 12
       },
       {
        "x": 5,
        "y": 14
       },
       {
        "x": -1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1523,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -5,
        "y": 14
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1525,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 2
       },
       {
        "x": -1,
        "y": 5
       },
       {
        "x": 9,
        "y": 6
       },
       {
        "x": -1,
        "y": 8
       },
       {
        "x": 9,
        "y": 12
       },
       {
        "x": 9,
        "y": 13
       },
       {
        "x": -1,
        "y": 13
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": -3,
        "y": 8
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1526,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -9,
        "y": 3
       },
       {
        "x": -5,
        "y": 10
       },
       {
        "x": -12,
        "y": 10
       },
       {
        "x": -12,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1528,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -12,
        "y": 0
       },
       {
        "x": -11,
        "y": -4
       },
       {
        "x": -14,
        "y": -13
       },
       {
        "x": -9,
        "y": -14
       },
       {
        "x": -8,
        "y": -16
       },
       {
        "x": -2,
        "y": -13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1529,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -13,
        "y": 15
       },
       {
        "x": -11,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1531,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       },
       {
        "x": -3,
        "y": -7
       },
       {
        "x": -12,
        "y": -10
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1532,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 3
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 3,
        "y": 8
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": 1,
        "y": 13
       },
       {
        "x": -9,
        "y": 13
       },
       {
        "x": -9,
        "y": 10
       },
       {
        "x": 1,
        "y": 8
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -9,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1538,
   "type": "ground"
  },
  {
   "id": 1539,
   "type": "ground"
  },
  {
   "id": 1540,
   "type": "ground"
  },
  {
   "id": 1541,
   "type": "ground"
  },
  {
   "id": 1544,
   "type": "ground"
  },
  {
   "id": 1545,
   "type": "ground"
  },
  {
   "id": 1550,
   "type": "ground"
  },
  {
   "id": 1551,
   "type": "ground"
  },
  {
   "id": 1552,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -2,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1553,
   "type": "ground"
  },
  {
   "id": 1554,
   "type": "ground"
  },
  {
   "id": 1555,
   "type": "ground"
  },
  {
   "id": 1556,
   "type": "ground"
  },
  {
   "id": 1557,
   "type": "ground"
  },
  {
   "id": 1558,
   "type": "ground"
  },
  {
   "id": 1559,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1564,
   "type": "ground"
  },
  {
   "id": 1565,
   "type": "ground"
  },
  {
   "id": 1566,
   "type": "ground"
  },
  {
   "id": 1567,
   "type": "ground"
  },
  {
   "id": 1570,
   "type": "ground"
  },
  {
   "id": 1571,
   "type": "ground"
  },
  {
   "id": 1576,
   "type": "ground"
  },
  {
   "id": 1577,
   "type": "ground"
  },
  {
   "id": 1578,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -2,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1579,
   "type": "ground"
  },
  {
   "id": 1580,
   "type": "ground"
  },
  {
   "id": 1581,
   "type": "ground"
  },
  {
   "id": 1582,
   "type": "ground"
  },
  {
   "id": 1583,
   "type": "ground"
  },
  {
   "id": 1584,
   "type": "ground"
  },
  {
   "id": 1585,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1590,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 14,
        "y": 15
       },
       {
        "x": 13,
        "y": 11
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1591,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -13,
        "y": 11
       },
       {
        "x": -14,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1592,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 14,
        "y": 15
       },
       {
        "x": 13,
        "y": 11
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1593,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -13,
        "y": 11
       },
       {
        "x": -14,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1601,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": 1,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1602,
   "type": "ground"
  },
  {
   "id": 1603,
   "type": "ground"
  },
  {
   "id": 1604,
   "type": "ground"
  },
  {
   "id": 1605,
   "type": "ground"
  },
  {
   "id": 1606,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 10
       },
       {
        "x": -4,
        "y": 12
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1608,
   "type": "ground"
  },
  {
   "id": 1609,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 14,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1610,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1611,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1612,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1613,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1614,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -14,
        "y": 9
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1615,
   "type": "ground"
  },
  {
   "id": 1617,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": -3
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1618,
   "type": "ground"
  },
  {
   "id": 1619,
   "type": "ground"
  },
  {
   "id": 1620,
   "type": "ground"
  },
  {
   "id": 1621,
   "type": "ground"
  },
  {
   "id": 1622,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1627,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": 1,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1628,
   "type": "ground"
  },
  {
   "id": 1629,
   "type": "ground"
  },
  {
   "id": 1630,
   "type": "ground"
  },
  {
   "id": 1631,
   "type": "ground"
  },
  {
   "id": 1632,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 10
       },
       {
        "x": -4,
        "y": 12
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1634,
   "type": "ground"
  },
  {
   "id": 1635,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 14,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1636,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1637,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1638,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1639,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1640,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -14,
        "y": 9
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1641,
   "type": "ground"
  },
  {
   "id": 1643,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": -3
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1644,
   "type": "ground"
  },
  {
   "id": 1645,
   "type": "ground"
  },
  {
   "id": 1646,
   "type": "ground"
  },
  {
   "id": 1647,
   "type": "ground"
  },
  {
   "id": 1648,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1651,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 10
       },
       {
        "x": -13,
        "y": 10
       },
       {
        "x": -11,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1652,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -13,
        "y": -9
       },
       {
        "x": -7,
        "y": -10
       },
       {
        "x": -8,
        "y": -12
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1660,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -4,
        "y": 5
       },
       {
        "x": -5,
        "y": 11
       },
       {
        "x": -16,
        "y": 11
       },
       {
        "x": -14,
        "y": -4
       },
       {
        "x": -5,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1661,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 1
       },
       {
        "x": 2,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1662,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 0
       },
       {
        "x": 2,
        "y": 5
       },
       {
        "x": -1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1663,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -11,
        "y": -4
       },
       {
        "x": -16,
        "y": -6
       },
       {
        "x": -16,
        "y": -11
       },
       {
        "x": -11,
        "y": -15
       },
       {
        "x": -2,
        "y": -15
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1665,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -4,
        "y": 12
       },
       {
        "x": -5,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1666,
   "type": "ground"
  },
  {
   "id": 1667,
   "type": "ground"
  },
  {
   "id": 1668,
   "type": "ground"
  },
  {
   "id": 1669,
   "type": "ground"
  },
  {
   "id": 1670,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 3
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1672,
   "type": "ground"
  },
  {
   "id": 1673,
   "type": "ground"
  },
  {
   "id": 1674,
   "type": "ground"
  },
  {
   "id": 1675,
   "type": "ground"
  },
  {
   "id": 1676,
   "type": "ground"
  },
  {
   "id": 1677,
   "type": "ground"
  },
  {
   "id": 1678,
   "type": "ground"
  },
  {
   "id": 1679,
   "type": "ground"
  },
  {
   "id": 1691,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -4,
        "y": 12
       },
       {
        "x": -5,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1692,
   "type": "ground"
  },
  {
   "id": 1693,
   "type": "ground"
  },
  {
   "id": 1694,
   "type": "ground"
  },
  {
   "id": 1695,
   "type": "ground"
  },
  {
   "id": 1696,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 3
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1698,
   "type": "ground"
  },
  {
   "id": 1699,
   "type": "ground"
  },
  {
   "id": 1700,
   "type": "ground"
  },
  {
   "id": 1701,
   "type": "ground"
  },
  {
   "id": 1702,
   "type": "ground"
  },
  {
   "id": 1703,
   "type": "ground"
  },
  {
   "id": 1704,
   "type": "ground"
  },
  {
   "id": 1705,
   "type": "ground"
  },
  {
   "id": 1715,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 4
       },
       {
        "x": -6,
        "y": 5
       },
       {
        "x": -8,
        "y": 14
       },
       {
        "x": -8,
        "y": 5
       },
       {
        "x": -13,
        "y": 4
       },
       {
        "x": -13,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1716,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": -10,
        "y": 12
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1724,
   "type": "ground"
  },
  {
   "id": 1725,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 1
       },
       {
        "x": 1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1726,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1727,
   "type": "ground"
  },
  {
   "id": 1729,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1730,
   "type": "ground"
  },
  {
   "id": 1731,
   "type": "ground"
  },
  {
   "id": 1732,
   "type": "ground"
  },
  {
   "id": 1733,
   "type": "ground"
  },
  {
   "id": 1734,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -4,
        "y": 12
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1736,
   "type": "ground"
  },
  {
   "id": 1737,
   "type": "ground"
  },
  {
   "id": 1738,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 1,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1739,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 11
       },
       {
        "x": -16,
        "y": 13
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1740,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1741,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1742,
   "type": "ground"
  },
  {
   "id": 1743,
   "type": "ground"
  },
  {
   "id": 1744,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -14,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1745,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": -7,
        "y": -3
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1746,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1747,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1748,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1749,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1750,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -9,
        "y": 0
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1751,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -10,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1755,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1756,
   "type": "ground"
  },
  {
   "id": 1757,
   "type": "ground"
  },
  {
   "id": 1758,
   "type": "ground"
  },
  {
   "id": 1759,
   "type": "ground"
  },
  {
   "id": 1760,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -4,
        "y": 12
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1762,
   "type": "ground"
  },
  {
   "id": 1763,
   "type": "ground"
  },
  {
   "id": 1764,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 1,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1765,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 11
       },
       {
        "x": -16,
        "y": 13
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1766,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1767,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1768,
   "type": "ground"
  },
  {
   "id": 1769,
   "type": "ground"
  },
  {
   "id": 1770,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -14,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1771,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": -7,
        "y": -3
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1772,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1773,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1774,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1775,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": -1
       },
       {
        "x": -7,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1776,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -9,
        "y": 0
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1777,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -10,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1782,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 14,
        "y": 15
       },
       {
        "x": 13,
        "y": 11
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1783,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -13,
        "y": 11
       },
       {
        "x": -13,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1784,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 13,
        "y": 15
       },
       {
        "x": 13,
        "y": 11
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1785,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -13,
        "y": 11
       },
       {
        "x": -14,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1788,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 8
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 11,
        "y": 14
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1789,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 1
       },
       {
        "x": 1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1790,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1791,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -11,
        "y": 14
       },
       {
        "x": -16,
        "y": 14
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -11,
        "y": 8
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1808,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -2,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1809,
   "type": "ground"
  },
  {
   "id": 1810,
   "type": "ground"
  },
  {
   "id": 1811,
   "type": "ground"
  },
  {
   "id": 1812,
   "type": "ground"
  },
  {
   "id": 1813,
   "type": "ground"
  },
  {
   "id": 1814,
   "type": "ground"
  },
  {
   "id": 1815,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1834,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -2,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1835,
   "type": "ground"
  },
  {
   "id": 1836,
   "type": "ground"
  },
  {
   "id": 1837,
   "type": "ground"
  },
  {
   "id": 1838,
   "type": "ground"
  },
  {
   "id": 1839,
   "type": "ground"
  },
  {
   "id": 1840,
   "type": "ground"
  },
  {
   "id": 1841,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1847,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 10
       },
       {
        "x": 10,
        "y": 11
       },
       {
        "x": 9,
        "y": 15
       },
       {
        "x": 5,
        "y": 15
       },
       {
        "x": 4,
        "y": 10
       },
       {
        "x": 1,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1848,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 8
       },
       {
        "x": 9,
        "y": 10
       },
       {
        "x": 8,
        "y": 15
       },
       {
        "x": 4,
        "y": 15
       },
       {
        "x": 3,
        "y": 11
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1852,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 3
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 12,
        "y": 10
       },
       {
        "x": 11,
        "y": 15
       },
       {
        "x": 2,
        "y": 15
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1853,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 1
       },
       {
        "x": 2,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1854,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 0
       },
       {
        "x": 2,
        "y": 5
       },
       {
        "x": -1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1855,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 15
       },
       {
        "x": -11,
        "y": 15
       },
       {
        "x": -12,
        "y": 10
       },
       {
        "x": -16,
        "y": 10
       },
       {
        "x": -16,
        "y": 5
       },
       {
        "x": -12,
        "y": 4
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1856,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 3,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 13
     }
    ]
   }
  },
  {
   "id": 1857,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -6,
        "y": -5
       },
       {
        "x": -2,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1862,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -14,
        "y": -1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1863,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -8,
        "y": -5
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1864,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1865,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1870,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1871,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1873,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 7,
        "y": 12
       },
       {
        "x": 5,
        "y": 4
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1874,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1875,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1876,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 1,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1877,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 11
       },
       {
        "x": -16,
        "y": 13
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1878,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -5,
        "y": 4
       },
       {
        "x": -7,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1882,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 3,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 13
     }
    ]
   }
  },
  {
   "id": 1883,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -6,
        "y": -5
       },
       {
        "x": -2,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1888,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -14,
        "y": -1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1889,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -8,
        "y": -5
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1890,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1891,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -11,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1896,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1897,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1899,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 7,
        "y": 12
       },
       {
        "x": 5,
        "y": 4
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1900,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1901,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1902,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 1,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1903,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 11
       },
       {
        "x": -16,
        "y": 13
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1904,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -5,
        "y": 4
       },
       {
        "x": -7,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1920,
   "type": "ground"
  },
  {
   "id": 1921,
   "type": "ground"
  },
  {
   "id": 1922,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -15,
        "y": -10
       },
       {
        "x": -13,
        "y": -11
       },
       {
        "x": -8,
        "y": -8
       },
       {
        "x": -7,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1925,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 10
       },
       {
        "x": -8,
        "y": 8
       },
       {
        "x": -7,
        "y": 2
       },
       {
        "x": -2,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1926,
   "type": "ground"
  },
  {
   "id": 1927,
   "type": "ground"
  },
  {
   "id": 1928,
   "type": "ground"
  },
  {
   "id": 1929,
   "type": "ground"
  },
  {
   "id": 1930,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1933,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1934,
   "type": "ground"
  },
  {
   "id": 1935,
   "type": "ground"
  },
  {
   "id": 1946,
   "type": "ground"
  },
  {
   "id": 1947,
   "type": "ground"
  },
  {
   "id": 1948,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -15,
        "y": -10
       },
       {
        "x": -13,
        "y": -11
       },
       {
        "x": -8,
        "y": -8
       },
       {
        "x": -7,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1951,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 10
       },
       {
        "x": -8,
        "y": 8
       },
       {
        "x": -7,
        "y": 2
       },
       {
        "x": -2,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1952,
   "type": "ground"
  },
  {
   "id": 1953,
   "type": "ground"
  },
  {
   "id": 1954,
   "type": "ground"
  },
  {
   "id": 1955,
   "type": "ground"
  },
  {
   "id": 1956,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1959,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1960,
   "type": "ground"
  },
  {
   "id": 1961,
   "type": "ground"
  },
  {
   "id": 1971,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 6
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1984,
   "type": "ground"
  },
  {
   "id": 1985,
   "type": "ground"
  },
  {
   "id": 1986,
   "type": "ground"
  },
  {
   "id": 1987,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1988,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1989,
   "type": "ground"
  },
  {
   "id": 1990,
   "type": "ground"
  },
  {
   "id": 1991,
   "type": "ground"
  },
  {
   "id": 1992,
   "type": "ground"
  },
  {
   "id": 1993,
   "type": "ground"
  },
  {
   "id": 1994,
   "type": "ground"
  },
  {
   "id": 1995,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1996,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 1997,
   "type": "ground"
  },
  {
   "id": 1998,
   "type": "ground"
  },
  {
   "id": 1999,
   "type": "ground"
  },
  {
   "id": 2000,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2001,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2002,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2003,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -4,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2004,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2005,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2006,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2007,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -10,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2010,
   "type": "ground"
  },
  {
   "id": 2011,
   "type": "ground"
  },
  {
   "id": 2012,
   "type": "ground"
  },
  {
   "id": 2013,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2014,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2015,
   "type": "ground"
  },
  {
   "id": 2016,
   "type": "ground"
  },
  {
   "id": 2017,
   "type": "ground"
  },
  {
   "id": 2018,
   "type": "ground"
  },
  {
   "id": 2019,
   "type": "ground"
  },
  {
   "id": 2020,
   "type": "ground"
  },
  {
   "id": 2021,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2022,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2023,
   "type": "ground"
  },
  {
   "id": 2024,
   "type": "ground"
  },
  {
   "id": 2025,
   "type": "ground"
  },
  {
   "id": 2026,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -15,
        "y": 3
       },
       {
        "x": -5,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2027,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -10,
        "y": -6
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2028,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -10,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2029,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -3
       },
       {
        "x": -4,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2030,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -6,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2031,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2032,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -16,
        "y": 1
       },
       {
        "x": -6,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2033,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -15,
        "y": 0
       },
       {
        "x": -15,
        "y": -3
       },
       {
        "x": -10,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2035,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -12,
        "y": 0
       },
       {
        "x": -11,
        "y": -4
       },
       {
        "x": -14,
        "y": -13
       },
       {
        "x": -9,
        "y": -14
       },
       {
        "x": -8,
        "y": -16
       },
       {
        "x": -2,
        "y": -13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2036,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -13,
        "y": 15
       },
       {
        "x": -11,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2039,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 12,
        "y": 10
       },
       {
        "x": 9,
        "y": 11
       },
       {
        "x": 8,
        "y": 15
       },
       {
        "x": 4,
        "y": 15
       },
       {
        "x": 3,
        "y": 10
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2040,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 12,
        "y": 8
       },
       {
        "x": 9,
        "y": 10
       },
       {
        "x": 8,
        "y": 15
       },
       {
        "x": 4,
        "y": 15
       },
       {
        "x": 3,
        "y": 11
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2048,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 4,
        "y": 6
       },
       {
        "x": 3,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2049,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 16,
        "y": -4
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2050,
   "type": "ground"
  },
  {
   "id": 2051,
   "type": "ground"
  },
  {
   "id": 2052,
   "type": "ground"
  },
  {
   "id": 2053,
   "type": "ground"
  },
  {
   "id": 2054,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -12
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2055,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 1
       },
       {
        "x": -4,
        "y": 6
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2056,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 4,
        "y": 6
       },
       {
        "x": 3,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2057,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 16,
        "y": -4
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2058,
   "type": "ground"
  },
  {
   "id": 2059,
   "type": "ground"
  },
  {
   "id": 2060,
   "type": "ground"
  },
  {
   "id": 2061,
   "type": "ground"
  },
  {
   "id": 2062,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -12
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2063,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 1
       },
       {
        "x": -4,
        "y": 6
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2064,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": -1,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2065,
   "type": "ground"
  },
  {
   "id": 2066,
   "type": "ground"
  },
  {
   "id": 2067,
   "type": "ground"
  },
  {
   "id": 2068,
   "type": "ground"
  },
  {
   "id": 2069,
   "type": "ground"
  },
  {
   "id": 2070,
   "type": "ground"
  },
  {
   "id": 2071,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2074,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 4,
        "y": 6
       },
       {
        "x": 3,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2075,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 16,
        "y": -4
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2076,
   "type": "ground"
  },
  {
   "id": 2077,
   "type": "ground"
  },
  {
   "id": 2078,
   "type": "ground"
  },
  {
   "id": 2079,
   "type": "ground"
  },
  {
   "id": 2080,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -12
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2081,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 1
       },
       {
        "x": -4,
        "y": 6
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2082,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 4,
        "y": 6
       },
       {
        "x": 3,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2083,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 16,
        "y": -4
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2084,
   "type": "ground"
  },
  {
   "id": 2085,
   "type": "ground"
  },
  {
   "id": 2086,
   "type": "ground"
  },
  {
   "id": 2087,
   "type": "ground"
  },
  {
   "id": 2088,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -12
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2089,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 1
       },
       {
        "x": -4,
        "y": 6
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2090,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": -1,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2091,
   "type": "ground"
  },
  {
   "id": 2092,
   "type": "ground"
  },
  {
   "id": 2093,
   "type": "ground"
  },
  {
   "id": 2094,
   "type": "ground"
  },
  {
   "id": 2095,
   "type": "ground"
  },
  {
   "id": 2096,
   "type": "ground"
  },
  {
   "id": 2097,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 10
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2102,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -7
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2103,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 7
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2106,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 4
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2107,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -14,
        "y": -4
       },
       {
        "x": -7,
        "y": -8
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2114,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2115,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 0,
        "y": -8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2116,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -1
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 0,
        "y": -9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2117,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2122,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2123,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 0,
        "y": -8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2124,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -1
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 0,
        "y": -9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2125,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2129,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 7,
        "y": 12
       },
       {
        "x": 5,
        "y": 4
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2130,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2131,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2132,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 1,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2133,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 11
       },
       {
        "x": -16,
        "y": 13
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2134,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -5,
        "y": 4
       },
       {
        "x": -7,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2140,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2141,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 0,
        "y": -8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2142,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -1
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 0,
        "y": -9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2143,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2148,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2149,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 0,
        "y": -8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2150,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -1
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 0,
        "y": -9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2151,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": -14,
        "y": 8
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2155,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 7,
        "y": 12
       },
       {
        "x": 5,
        "y": 4
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2156,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 0,
        "y": -10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2157,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2158,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 1,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2159,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 11
       },
       {
        "x": -16,
        "y": 13
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2160,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -5,
        "y": 4
       },
       {
        "x": -7,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2164,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -14,
        "y": 6
       },
       {
        "x": -14,
        "y": 2
       },
       {
        "x": -8,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2165,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -13,
        "y": 10
       },
       {
        "x": -16,
        "y": 10
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -11,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2166,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -6
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2167,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2168,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -7,
        "y": 6
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -10,
        "y": 3
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2169,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 2
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 4,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2170,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -12,
        "y": 0
       },
       {
        "x": -16,
        "y": -11
       },
       {
        "x": -10,
        "y": -16
       },
       {
        "x": 0,
        "y": -14
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2171,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 2
       },
       {
        "x": 2,
        "y": 8
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -14,
        "y": 2
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2172,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 0
       },
       {
        "x": -5,
        "y": -4
       },
       {
        "x": -13,
        "y": -5
       },
       {
        "x": -16,
        "y": -8
       },
       {
        "x": -5,
        "y": -13
       },
       {
        "x": 0,
        "y": -6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2173,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -6
       },
       {
        "x": -6,
        "y": -8
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2176,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -3,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2177,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2178,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -15
       },
       {
        "x": -6,
        "y": -16
       },
       {
        "x": 0,
        "y": -13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2179,
   "type": "ground"
  },
  {
   "id": 2180,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2181,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2182,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 15
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2183,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2184,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2185,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 0
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2186,
   "type": "ground"
  },
  {
   "id": 2187,
   "type": "ground"
  },
  {
   "id": 2188,
   "type": "ground"
  },
  {
   "id": 2189,
   "type": "ground"
  },
  {
   "id": 2190,
   "type": "ground"
  },
  {
   "id": 2191,
   "type": "ground"
  },
  {
   "id": 2192,
   "type": "ground"
  },
  {
   "id": 2193,
   "type": "ground"
  },
  {
   "id": 2194,
   "type": "ground"
  },
  {
   "id": 2195,
   "type": "ground"
  },
  {
   "id": 2196,
   "type": "ground"
  },
  {
   "id": 2197,
   "type": "ground"
  },
  {
   "id": 2198,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2199,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2212,
   "type": "ground"
  },
  {
   "id": 2213,
   "type": "ground"
  },
  {
   "id": 2214,
   "type": "ground"
  },
  {
   "id": 2215,
   "type": "ground"
  },
  {
   "id": 2216,
   "type": "ground"
  },
  {
   "id": 2217,
   "type": "ground"
  },
  {
   "id": 2218,
   "type": "ground"
  },
  {
   "id": 2219,
   "type": "ground"
  },
  {
   "id": 2220,
   "type": "ground"
  },
  {
   "id": 2221,
   "type": "ground"
  },
  {
   "id": 2222,
   "type": "ground"
  },
  {
   "id": 2223,
   "type": "ground"
  },
  {
   "id": 2224,
   "type": "ground"
  },
  {
   "id": 2225,
   "type": "ground"
  },
  {
   "id": 2227,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -13,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2228,
   "type": "ground"
  },
  {
   "id": 2229,
   "type": "ground"
  },
  {
   "id": 2230,
   "type": "ground"
  },
  {
   "id": 2231,
   "type": "ground"
  },
  {
   "id": 2232,
   "type": "ground"
  },
  {
   "id": 2233,
   "type": "ground"
  },
  {
   "id": 2234,
   "type": "ground"
  },
  {
   "id": 2235,
   "type": "ground"
  },
  {
   "id": 2236,
   "type": "ground"
  },
  {
   "id": 2237,
   "type": "ground"
  },
  {
   "id": 2238,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 7
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2240,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": -16
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2241,
   "type": "ground"
  },
  {
   "id": 2242,
   "type": "ground"
  },
  {
   "id": 2243,
   "type": "ground"
  },
  {
   "id": 2244,
   "type": "ground"
  },
  {
   "id": 2245,
   "type": "ground"
  },
  {
   "id": 2246,
   "type": "ground"
  },
  {
   "id": 2247,
   "type": "ground"
  },
  {
   "id": 2248,
   "type": "ground"
  },
  {
   "id": 2249,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2250,
   "type": "ground"
  },
  {
   "id": 2251,
   "type": "ground"
  },
  {
   "id": 2252,
   "type": "ground"
  },
  {
   "id": 2253,
   "type": "ground"
  },
  {
   "id": 2254,
   "type": "ground"
  },
  {
   "id": 2255,
   "type": "ground"
  },
  {
   "id": 2256,
   "type": "ground"
  },
  {
   "id": 2257,
   "type": "ground"
  },
  {
   "id": 2258,
   "type": "ground"
  },
  {
   "id": 2259,
   "type": "ground"
  },
  {
   "id": 2260,
   "type": "ground"
  },
  {
   "id": 2261,
   "type": "ground"
  },
  {
   "id": 2262,
   "type": "ground"
  },
  {
   "id": 2263,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 9,
        "y": 6
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2268,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 1
       },
       {
        "x": -8,
        "y": 7
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2269,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 14,
        "y": 5
       },
       {
        "x": 10,
        "y": 12
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 10
       },
       {
        "x": 3,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2270,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 3
       },
       {
        "x": 2,
        "y": 10
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -10,
        "y": 12
       },
       {
        "x": -14,
        "y": 5
       },
       {
        "x": -6,
        "y": 4
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2271,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 5,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2276,
   "type": "ground"
  },
  {
   "id": 2277,
   "type": "ground"
  },
  {
   "id": 2278,
   "type": "ground"
  },
  {
   "id": 2279,
   "type": "ground"
  },
  {
   "id": 2280,
   "type": "ground"
  },
  {
   "id": 2281,
   "type": "ground"
  },
  {
   "id": 2282,
   "type": "ground"
  },
  {
   "id": 2283,
   "type": "ground"
  },
  {
   "id": 2284,
   "type": "ground"
  },
  {
   "id": 2285,
   "type": "ground"
  },
  {
   "id": 2286,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2287,
   "type": "ground"
  },
  {
   "id": 2288,
   "type": "ground"
  },
  {
   "id": 2289,
   "type": "ground"
  },
  {
   "id": 2291,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 13
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 8,
        "y": 11
       },
       {
        "x": 1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2292,
   "type": "ground"
  },
  {
   "id": 2293,
   "type": "ground"
  },
  {
   "id": 2294,
   "type": "ground"
  },
  {
   "id": 2295,
   "type": "ground"
  },
  {
   "id": 2296,
   "type": "ground"
  },
  {
   "id": 2297,
   "type": "ground"
  },
  {
   "id": 2298,
   "type": "ground"
  },
  {
   "id": 2299,
   "type": "ground"
  },
  {
   "id": 2300,
   "type": "ground"
  },
  {
   "id": 2301,
   "type": "ground"
  },
  {
   "id": 2302,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": -8,
        "y": 11
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -14,
        "y": 13
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2304,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": -16
       },
       {
        "x": 10,
        "y": -16
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2305,
   "type": "ground"
  },
  {
   "id": 2306,
   "type": "ground"
  },
  {
   "id": 2307,
   "type": "ground"
  },
  {
   "id": 2308,
   "type": "ground"
  },
  {
   "id": 2309,
   "type": "ground"
  },
  {
   "id": 2310,
   "type": "ground"
  },
  {
   "id": 2311,
   "type": "ground"
  },
  {
   "id": 2312,
   "type": "ground"
  },
  {
   "id": 2313,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2314,
   "type": "ground"
  },
  {
   "id": 2315,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2322,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -11,
        "y": 2
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2323,
   "type": "ground"
  },
  {
   "id": 2324,
   "type": "ground"
  },
  {
   "id": 2325,
   "type": "ground"
  },
  {
   "id": 2326,
   "type": "ground"
  },
  {
   "id": 2327,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": -2,
        "y": 11
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2330,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 10
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -10,
        "y": 6
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2331,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -8,
        "y": -6
       },
       {
        "x": -16,
        "y": -7
       },
       {
        "x": -16,
        "y": -10
       },
       {
        "x": -10,
        "y": -11
       },
       {
        "x": -10,
        "y": -13
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2332,
   "type": "ground"
  },
  {
   "id": 2333,
   "type": "ground"
  },
  {
   "id": 2334,
   "type": "ground"
  },
  {
   "id": 2335,
   "type": "ground"
  },
  {
   "id": 2336,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -8,
        "y": 4
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -2,
        "y": 10
       },
       {
        "x": -16,
        "y": 10
       },
       {
        "x": -16,
        "y": -1
       },
       {
        "x": -6,
        "y": -3
       },
       {
        "x": -6,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2337,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": -2
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 8,
        "y": 8
       },
       {
        "x": 3,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2340,
   "type": "ground"
  },
  {
   "id": 2341,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 16,
        "y": 4
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2342,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2343,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 3
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": -16,
        "y": 7
       },
       {
        "x": -16,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2344,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 12,
        "y": 6
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": 3,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2345,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 5,
        "y": 1
       },
       {
        "x": 15,
        "y": 6
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 13,
        "y": 13
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": 7,
        "y": 9
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2346,
   "type": "ground"
  },
  {
   "id": 2347,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 12
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2348,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 14
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -16,
        "y": 11
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2349,
   "type": "ground"
  },
  {
   "id": 2350,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 10,
        "y": 8
       },
       {
        "x": 2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2351,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 4
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -14,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2352,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2353,
   "type": "ground"
  },
  {
   "id": 2354,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -5,
        "y": 8
       },
       {
        "x": -5,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2355,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2356,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2357,
   "type": "ground"
  },
  {
   "id": 2358,
   "type": "ground"
  },
  {
   "id": 2359,
   "type": "ground"
  },
  {
   "id": 2360,
   "type": "ground"
  },
  {
   "id": 2361,
   "type": "ground"
  },
  {
   "id": 2362,
   "type": "ground"
  },
  {
   "id": 2363,
   "type": "ground"
  },
  {
   "id": 2364,
   "type": "ground"
  },
  {
   "id": 2365,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2366,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2367,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 2
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2368,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 10,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2369,
   "type": "ground"
  },
  {
   "id": 2370,
   "type": "ground"
  },
  {
   "id": 2371,
   "type": "ground"
  },
  {
   "id": 2372,
   "type": "ground"
  },
  {
   "id": 2373,
   "type": "ground"
  },
  {
   "id": 2374,
   "type": "ground"
  },
  {
   "id": 2375,
   "type": "ground"
  },
  {
   "id": 2376,
   "type": "ground"
  },
  {
   "id": 2377,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2378,
   "type": "ground"
  },
  {
   "id": 2379,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2386,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2387,
   "type": "ground"
  },
  {
   "id": 2388,
   "type": "ground"
  },
  {
   "id": 2389,
   "type": "ground"
  },
  {
   "id": 2390,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2391,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -6,
        "y": 3
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2394,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -6,
        "y": 2
       },
       {
        "x": -5,
        "y": 6
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -14,
        "y": 15
       },
       {
        "x": -15,
        "y": 8
       },
       {
        "x": -8,
        "y": 5
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2395,
   "type": "ground"
  },
  {
   "id": 2396,
   "type": "ground"
  },
  {
   "id": 2397,
   "type": "ground"
  },
  {
   "id": 2398,
   "type": "ground"
  },
  {
   "id": 2399,
   "type": "ground"
  },
  {
   "id": 2400,
   "type": "ground"
  },
  {
   "id": 2401,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -6
       },
       {
        "x": -8,
        "y": -11
       },
       {
        "x": -8,
        "y": -13
       },
       {
        "x": -14,
        "y": -15
       },
       {
        "x": -5,
        "y": -15
       },
       {
        "x": -6,
        "y": -10
       },
       {
        "x": 1,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2404,
   "type": "ground"
  },
  {
   "id": 2405,
   "type": "ground"
  },
  {
   "id": 2406,
   "type": "ground"
  },
  {
   "id": 2407,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 5
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2408,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": 9,
        "y": 7
       },
       {
        "x": 6,
        "y": 5
       },
       {
        "x": 8,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2409,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 7
       },
       {
        "x": -13,
        "y": 7
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2412,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 3,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2413,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 8
       },
       {
        "x": -14,
        "y": 4
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2414,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2415,
   "type": "ground"
  },
  {
   "id": 2416,
   "type": "ground"
  },
  {
   "id": 2417,
   "type": "ground"
  },
  {
   "id": 2418,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 5,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2419,
   "type": "ground"
  },
  {
   "id": 2420,
   "type": "ground"
  },
  {
   "id": 2421,
   "type": "ground"
  },
  {
   "id": 2422,
   "type": "ground"
  },
  {
   "id": 2423,
   "type": "ground"
  },
  {
   "id": 2424,
   "type": "ground"
  },
  {
   "id": 2425,
   "type": "ground"
  },
  {
   "id": 2426,
   "type": "ground"
  },
  {
   "id": 2427,
   "type": "ground"
  },
  {
   "id": 2428,
   "type": "ground"
  },
  {
   "id": 2429,
   "type": "ground"
  },
  {
   "id": 2430,
   "type": "ground"
  },
  {
   "id": 2431,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -6,
        "y": 5
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2432,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 3,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2433,
   "type": "ground"
  },
  {
   "id": 2434,
   "type": "ground"
  },
  {
   "id": 2435,
   "type": "ground"
  },
  {
   "id": 2436,
   "type": "ground"
  },
  {
   "id": 2437,
   "type": "ground"
  },
  {
   "id": 2438,
   "type": "ground"
  },
  {
   "id": 2439,
   "type": "ground"
  },
  {
   "id": 2440,
   "type": "ground"
  },
  {
   "id": 2441,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 5
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2442,
   "type": "ground"
  },
  {
   "id": 2443,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 9,
        "y": 4
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2446,
   "type": "ground"
  },
  {
   "id": 2447,
   "type": "ground"
  },
  {
   "id": 2450,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -9,
        "y": 4
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2451,
   "type": "ground"
  },
  {
   "id": 2452,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2453,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2454,
   "type": "ground"
  },
  {
   "id": 2455,
   "type": "ground"
  },
  {
   "id": 2457,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -13,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2458,
   "type": "ground"
  },
  {
   "id": 2459,
   "type": "ground"
  },
  {
   "id": 2460,
   "type": "ground"
  },
  {
   "id": 2461,
   "type": "ground"
  },
  {
   "id": 2462,
   "type": "ground"
  },
  {
   "id": 2463,
   "type": "ground"
  },
  {
   "id": 2464,
   "type": "ground"
  },
  {
   "id": 2465,
   "type": "ground"
  },
  {
   "id": 2466,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 7
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2468,
   "type": "ground"
  },
  {
   "id": 2469,
   "type": "ground"
  },
  {
   "id": 2470,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2479,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -14,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2480,
   "type": "ground"
  },
  {
   "id": 2481,
   "type": "ground"
  },
  {
   "id": 2483,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -14,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2484,
   "type": "ground"
  },
  {
   "id": 2485,
   "type": "ground"
  },
  {
   "id": 2486,
   "type": "ground"
  },
  {
   "id": 2487,
   "type": "ground"
  },
  {
   "id": 2488,
   "type": "ground"
  },
  {
   "id": 2489,
   "type": "ground"
  },
  {
   "id": 2490,
   "type": "ground"
  },
  {
   "id": 2491,
   "type": "ground"
  },
  {
   "id": 2492,
   "type": "ground"
  },
  {
   "id": 2493,
   "type": "ground"
  },
  {
   "id": 2494,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2496,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -16
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2497,
   "type": "ground"
  },
  {
   "id": 2498,
   "type": "ground"
  },
  {
   "id": 2499,
   "type": "ground"
  },
  {
   "id": 2500,
   "type": "ground"
  },
  {
   "id": 2501,
   "type": "ground"
  },
  {
   "id": 2502,
   "type": "ground"
  },
  {
   "id": 2503,
   "type": "ground"
  },
  {
   "id": 2504,
   "type": "ground"
  },
  {
   "id": 2505,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2506,
   "type": "ground"
  },
  {
   "id": 2507,
   "type": "ground"
  },
  {
   "id": 2510,
   "type": "ground"
  },
  {
   "id": 2511,
   "type": "ground"
  },
  {
   "id": 2514,
   "type": "ground"
  },
  {
   "id": 2515,
   "type": "ground"
  },
  {
   "id": 2516,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -9,
        "y": 6
       },
       {
        "x": -6,
        "y": 4
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2517,
   "type": "ground"
  },
  {
   "id": 2518,
   "type": "ground"
  },
  {
   "id": 2519,
   "type": "ground"
  },
  {
   "id": 2521,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 13
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 8,
        "y": 11
       },
       {
        "x": 1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2522,
   "type": "ground"
  },
  {
   "id": 2523,
   "type": "ground"
  },
  {
   "id": 2524,
   "type": "ground"
  },
  {
   "id": 2525,
   "type": "ground"
  },
  {
   "id": 2526,
   "type": "ground"
  },
  {
   "id": 2527,
   "type": "ground"
  },
  {
   "id": 2528,
   "type": "ground"
  },
  {
   "id": 2529,
   "type": "ground"
  },
  {
   "id": 2530,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": -8,
        "y": 11
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -14,
        "y": 13
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2532,
   "type": "ground"
  },
  {
   "id": 2533,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 13
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2534,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": -4
       },
       {
        "x": -2,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2535,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 3
       },
       {
        "x": -3,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2542,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": -3
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2543,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": -7
       },
       {
        "x": -14,
        "y": -12
       },
       {
        "x": -11,
        "y": -16
       },
       {
        "x": 2,
        "y": -16
       },
       {
        "x": 2,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2544,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 0,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2545,
   "type": "ground"
  },
  {
   "id": 2546,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": -3
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2547,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": -7
       },
       {
        "x": -14,
        "y": -12
       },
       {
        "x": -11,
        "y": -16
       },
       {
        "x": 2,
        "y": -16
       },
       {
        "x": 2,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2548,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 0,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2549,
   "type": "ground"
  },
  {
   "id": 2550,
   "type": "ground"
  },
  {
   "id": 2551,
   "type": "ground"
  },
  {
   "id": 2552,
   "type": "ground"
  },
  {
   "id": 2553,
   "type": "ground"
  },
  {
   "id": 2554,
   "type": "ground"
  },
  {
   "id": 2555,
   "type": "ground"
  },
  {
   "id": 2556,
   "type": "ground"
  },
  {
   "id": 2557,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 13
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2558,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": -4
       },
       {
        "x": -2,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2559,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 3
       },
       {
        "x": -3,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2560,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -16
       },
       {
        "x": 13,
        "y": -16
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2561,
   "type": "ground"
  },
  {
   "id": 2562,
   "type": "ground"
  },
  {
   "id": 2563,
   "type": "ground"
  },
  {
   "id": 2564,
   "type": "ground"
  },
  {
   "id": 2565,
   "type": "ground"
  },
  {
   "id": 2566,
   "type": "ground"
  },
  {
   "id": 2567,
   "type": "ground"
  },
  {
   "id": 2568,
   "type": "ground"
  },
  {
   "id": 2569,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2570,
   "type": "ground"
  },
  {
   "id": 2571,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 9,
        "y": 7
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2578,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2579,
   "type": "ground"
  },
  {
   "id": 2580,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": 2,
        "y": 11
       },
       {
        "x": -1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2581,
   "type": "ground"
  },
  {
   "id": 2582,
   "type": "ground"
  },
  {
   "id": 2583,
   "type": "ground"
  },
  {
   "id": 2585,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 2
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -4,
        "y": 4
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2586,
   "type": "ground"
  },
  {
   "id": 2587,
   "type": "ground"
  },
  {
   "id": 2588,
   "type": "ground"
  },
  {
   "id": 2589,
   "type": "ground"
  },
  {
   "id": 2590,
   "type": "ground"
  },
  {
   "id": 2591,
   "type": "ground"
  },
  {
   "id": 2592,
   "type": "ground"
  },
  {
   "id": 2593,
   "type": "ground"
  },
  {
   "id": 2594,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 4,
        "y": 4
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2596,
   "type": "ground"
  },
  {
   "id": 2597,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2598,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2599,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 3
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2600,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -7
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2601,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 7
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2604,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 4
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2605,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -14,
        "y": -4
       },
       {
        "x": -7,
        "y": -8
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2606,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -3
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2607,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2608,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2609,
   "type": "ground"
  },
  {
   "id": 2611,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2612,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2613,
   "type": "ground"
  },
  {
   "id": 2614,
   "type": "ground"
  },
  {
   "id": 2615,
   "type": "ground"
  },
  {
   "id": 2616,
   "type": "ground"
  },
  {
   "id": 2617,
   "type": "ground"
  },
  {
   "id": 2618,
   "type": "ground"
  },
  {
   "id": 2619,
   "type": "ground"
  },
  {
   "id": 2620,
   "type": "ground"
  },
  {
   "id": 2621,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2622,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2624,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2625,
   "type": "ground"
  },
  {
   "id": 2626,
   "type": "ground"
  },
  {
   "id": 2627,
   "type": "ground"
  },
  {
   "id": 2628,
   "type": "ground"
  },
  {
   "id": 2629,
   "type": "ground"
  },
  {
   "id": 2630,
   "type": "ground"
  },
  {
   "id": 2631,
   "type": "ground"
  },
  {
   "id": 2632,
   "type": "ground"
  },
  {
   "id": 2633,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2634,
   "type": "ground"
  },
  {
   "id": 2635,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2642,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2643,
   "type": "ground"
  },
  {
   "id": 2644,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2645,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": -3
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2646,
   "type": "ground"
  },
  {
   "id": 2647,
   "type": "ground"
  },
  {
   "id": 2649,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2650,
   "type": "ground"
  },
  {
   "id": 2651,
   "type": "ground"
  },
  {
   "id": 2652,
   "type": "ground"
  },
  {
   "id": 2653,
   "type": "ground"
  },
  {
   "id": 2654,
   "type": "ground"
  },
  {
   "id": 2655,
   "type": "ground"
  },
  {
   "id": 2656,
   "type": "ground"
  },
  {
   "id": 2657,
   "type": "ground"
  },
  {
   "id": 2658,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 3
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2660,
   "type": "ground"
  },
  {
   "id": 2661,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2662,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 6
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2663,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 1
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -11,
        "y": -1
       },
       {
        "x": -9,
        "y": -5
       },
       {
        "x": -4,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2664,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -6
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2665,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2666,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -7,
        "y": 6
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -10,
        "y": 3
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2667,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 2
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 4,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2668,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -12,
        "y": 0
       },
       {
        "x": -16,
        "y": -11
       },
       {
        "x": -10,
        "y": -16
       },
       {
        "x": 0,
        "y": -14
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2669,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 2
       },
       {
        "x": 2,
        "y": 8
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -14,
        "y": 2
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2670,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": -1
       },
       {
        "x": -16,
        "y": -4
       },
       {
        "x": -12,
        "y": -9
       },
       {
        "x": -6,
        "y": -9
       },
       {
        "x": -5,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2671,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": 2,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2672,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2673,
   "type": "ground"
  },
  {
   "id": 2675,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 14
       },
       {
        "x": 16,
        "y": -2
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2676,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2677,
   "type": "ground"
  },
  {
   "id": 2678,
   "type": "ground"
  },
  {
   "id": 2679,
   "type": "ground"
  },
  {
   "id": 2680,
   "type": "ground"
  },
  {
   "id": 2681,
   "type": "ground"
  },
  {
   "id": 2682,
   "type": "ground"
  },
  {
   "id": 2683,
   "type": "ground"
  },
  {
   "id": 2684,
   "type": "ground"
  },
  {
   "id": 2685,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2686,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -14
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2688,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": -1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2689,
   "type": "ground"
  },
  {
   "id": 2690,
   "type": "ground"
  },
  {
   "id": 2691,
   "type": "ground"
  },
  {
   "id": 2692,
   "type": "ground"
  },
  {
   "id": 2693,
   "type": "ground"
  },
  {
   "id": 2694,
   "type": "ground"
  },
  {
   "id": 2695,
   "type": "ground"
  },
  {
   "id": 2696,
   "type": "ground"
  },
  {
   "id": 2697,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2698,
   "type": "ground"
  },
  {
   "id": 2699,
   "type": "ground"
  },
  {
   "id": 2700,
   "type": "ground"
  },
  {
   "id": 2701,
   "type": "ground"
  },
  {
   "id": 2702,
   "type": "ground"
  },
  {
   "id": 2703,
   "type": "ground"
  },
  {
   "id": 2704,
   "type": "ground"
  },
  {
   "id": 2705,
   "type": "ground"
  },
  {
   "id": 2706,
   "type": "ground"
  },
  {
   "id": 2707,
   "type": "ground"
  },
  {
   "id": 2714,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 5
       },
       {
        "x": 8,
        "y": 10
       },
       {
        "x": 8,
        "y": 12
       },
       {
        "x": 14,
        "y": 13
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 6,
        "y": 9
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2715,
   "type": "ground"
  },
  {
   "id": 2716,
   "type": "ground"
  },
  {
   "id": 2717,
   "type": "ground"
  },
  {
   "id": 2718,
   "type": "ground"
  },
  {
   "id": 2719,
   "type": "ground"
  },
  {
   "id": 2720,
   "type": "ground"
  },
  {
   "id": 2721,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 6
       },
       {
        "x": -6,
        "y": 9
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -14,
        "y": 13
       },
       {
        "x": -8,
        "y": 12
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -14,
        "y": 5
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2724,
   "type": "ground"
  },
  {
   "id": 2725,
   "type": "ground"
  },
  {
   "id": 2726,
   "type": "ground"
  },
  {
   "id": 2727,
   "type": "ground"
  },
  {
   "id": 2728,
   "type": "ground"
  },
  {
   "id": 2729,
   "type": "ground"
  },
  {
   "id": 2730,
   "type": "ground"
  },
  {
   "id": 2731,
   "type": "ground"
  },
  {
   "id": 2732,
   "type": "ground"
  },
  {
   "id": 2733,
   "type": "ground"
  },
  {
   "id": 2734,
   "type": "ground"
  },
  {
   "id": 2735,
   "type": "ground"
  },
  {
   "id": 2736,
   "type": "ground"
  },
  {
   "id": 2737,
   "type": "ground"
  },
  {
   "id": 2739,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 2
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -4,
        "y": 4
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2740,
   "type": "ground"
  },
  {
   "id": 2741,
   "type": "ground"
  },
  {
   "id": 2742,
   "type": "ground"
  },
  {
   "id": 2743,
   "type": "ground"
  },
  {
   "id": 2744,
   "type": "ground"
  },
  {
   "id": 2745,
   "type": "ground"
  },
  {
   "id": 2746,
   "type": "ground"
  },
  {
   "id": 2747,
   "type": "ground"
  },
  {
   "id": 2748,
   "type": "ground"
  },
  {
   "id": 2749,
   "type": "ground"
  },
  {
   "id": 2750,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 4,
        "y": 4
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2752,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 7
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2753,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 0,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2754,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -16,
        "y": 14
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2755,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2756,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2757,
   "type": "ground"
  },
  {
   "id": 2758,
   "type": "ground"
  },
  {
   "id": 2759,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 14
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2760,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2761,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": -3,
        "y": 7
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2762,
   "type": "ground"
  },
  {
   "id": 2763,
   "type": "ground"
  },
  {
   "id": 2764,
   "type": "ground"
  },
  {
   "id": 2765,
   "type": "ground"
  },
  {
   "id": 2766,
   "type": "ground"
  },
  {
   "id": 2767,
   "type": "ground"
  },
  {
   "id": 2768,
   "type": "ground"
  },
  {
   "id": 2769,
   "type": "ground"
  },
  {
   "id": 2770,
   "type": "ground"
  },
  {
   "id": 2771,
   "type": "ground"
  },
  {
   "id": 2778,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 8,
        "y": 10
       },
       {
        "x": 4,
        "y": 10
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": -2,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2779,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -10,
        "y": 13
       },
       {
        "x": -10,
        "y": 10
       },
       {
        "x": -16,
        "y": 10
       },
       {
        "x": -16,
        "y": 6
       },
       {
        "x": -8,
        "y": 5
       },
       {
        "x": -13,
        "y": 3
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2780,
   "type": "ground"
  },
  {
   "id": 2781,
   "type": "ground"
  },
  {
   "id": 2782,
   "type": "ground"
  },
  {
   "id": 2783,
   "type": "ground"
  },
  {
   "id": 2784,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 13,
        "y": 3
       },
       {
        "x": 8,
        "y": 5
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 10,
        "y": 10
       },
       {
        "x": 10,
        "y": 13
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2785,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 3
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -4,
        "y": 10
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2788,
   "type": "ground"
  },
  {
   "id": 2789,
   "type": "ground"
  },
  {
   "id": 2790,
   "type": "ground"
  },
  {
   "id": 2791,
   "type": "ground"
  },
  {
   "id": 2792,
   "type": "ground"
  },
  {
   "id": 2793,
   "type": "ground"
  },
  {
   "id": 2794,
   "type": "ground"
  },
  {
   "id": 2795,
   "type": "ground"
  },
  {
   "id": 2796,
   "type": "ground"
  },
  {
   "id": 2797,
   "type": "ground"
  },
  {
   "id": 2798,
   "type": "ground"
  },
  {
   "id": 2799,
   "type": "ground"
  },
  {
   "id": 2800,
   "type": "ground"
  },
  {
   "id": 2801,
   "type": "ground"
  },
  {
   "id": 2803,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2804,
   "type": "ground"
  },
  {
   "id": 2805,
   "type": "ground"
  },
  {
   "id": 2806,
   "type": "ground"
  },
  {
   "id": 2807,
   "type": "ground"
  },
  {
   "id": 2808,
   "type": "ground"
  },
  {
   "id": 2809,
   "type": "ground"
  },
  {
   "id": 2810,
   "type": "ground"
  },
  {
   "id": 2811,
   "type": "ground"
  },
  {
   "id": 2812,
   "type": "ground"
  },
  {
   "id": 2813,
   "type": "ground"
  },
  {
   "id": 2814,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 3
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2844,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 6
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 8,
        "y": 13
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 5,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2845,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 3
       },
       {
        "x": 3,
        "y": 10
       },
       {
        "x": -5,
        "y": 11
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -8,
        "y": 12
       },
       {
        "x": -13,
        "y": 6
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2846,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 6
       },
       {
        "x": 8,
        "y": 12
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 5,
        "y": 11
       },
       {
        "x": -3,
        "y": 10
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2847,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 9
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -9,
        "y": 14
       },
       {
        "x": -6,
        "y": 8
       },
       {
        "x": -13,
        "y": 6
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2868,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 6
       },
       {
        "x": 11,
        "y": 8
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2869,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 4
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 5,
        "y": 13
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2870,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 12,
        "y": 6
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -1,
        "y": 10
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": 3,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2871,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 5,
        "y": 1
       },
       {
        "x": 15,
        "y": 6
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 13,
        "y": 13
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": 7,
        "y": 9
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2872,
   "type": "ground"
  },
  {
   "id": 2873,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 12
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2874,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 14
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -16,
        "y": 11
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2875,
   "type": "ground"
  },
  {
   "id": 2876,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -5,
        "y": 13
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -13,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2877,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -6,
        "y": 8
       },
       {
        "x": -11,
        "y": 8
       },
       {
        "x": -14,
        "y": 6
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2934,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": 9,
        "y": 7
       },
       {
        "x": 6,
        "y": 5
       },
       {
        "x": 8,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2935,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 7
       },
       {
        "x": -13,
        "y": 7
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2938,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 3,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2939,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 8
       },
       {
        "x": -14,
        "y": 4
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2998,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -7
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 2999,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 7
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3002,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 4
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3003,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -14,
        "y": -4
       },
       {
        "x": -7,
        "y": -8
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3060,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -14,
        "y": 6
       },
       {
        "x": -14,
        "y": 2
       },
       {
        "x": -8,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3061,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 5
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -13,
        "y": 10
       },
       {
        "x": -16,
        "y": 10
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -11,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3062,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -6
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3063,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3064,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -7,
        "y": 6
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -10,
        "y": 3
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3065,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 2
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 4,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3066,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -12,
        "y": 0
       },
       {
        "x": -16,
        "y": -11
       },
       {
        "x": -10,
        "y": -16
       },
       {
        "x": 0,
        "y": -14
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3067,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 2
       },
       {
        "x": 2,
        "y": 8
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -14,
        "y": 2
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3068,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 0
       },
       {
        "x": -5,
        "y": -4
       },
       {
        "x": -13,
        "y": -5
       },
       {
        "x": -16,
        "y": -8
       },
       {
        "x": -5,
        "y": -13
       },
       {
        "x": 0,
        "y": -6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3069,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -6
       },
       {
        "x": -6,
        "y": -8
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3072,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -3,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3073,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3074,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -15
       },
       {
        "x": -6,
        "y": -16
       },
       {
        "x": 0,
        "y": -13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3075,
   "type": "ground"
  },
  {
   "id": 3076,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3077,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3078,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 15
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3079,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 3
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3080,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3081,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 10,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 0
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3082,
   "type": "ground"
  },
  {
   "id": 3083,
   "type": "ground"
  },
  {
   "id": 3084,
   "type": "ground"
  },
  {
   "id": 3085,
   "type": "ground"
  },
  {
   "id": 3086,
   "type": "ground"
  },
  {
   "id": 3087,
   "type": "ground"
  },
  {
   "id": 3088,
   "type": "ground"
  },
  {
   "id": 3089,
   "type": "ground"
  },
  {
   "id": 3090,
   "type": "ground"
  },
  {
   "id": 3091,
   "type": "ground"
  },
  {
   "id": 3092,
   "type": "ground"
  },
  {
   "id": 3093,
   "type": "ground"
  },
  {
   "id": 3094,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3095,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3108,
   "type": "ground"
  },
  {
   "id": 3109,
   "type": "ground"
  },
  {
   "id": 3110,
   "type": "ground"
  },
  {
   "id": 3111,
   "type": "ground"
  },
  {
   "id": 3112,
   "type": "ground"
  },
  {
   "id": 3113,
   "type": "ground"
  },
  {
   "id": 3114,
   "type": "ground"
  },
  {
   "id": 3115,
   "type": "ground"
  },
  {
   "id": 3116,
   "type": "ground"
  },
  {
   "id": 3117,
   "type": "ground"
  },
  {
   "id": 3118,
   "type": "ground"
  },
  {
   "id": 3119,
   "type": "ground"
  },
  {
   "id": 3120,
   "type": "ground"
  },
  {
   "id": 3121,
   "type": "ground"
  },
  {
   "id": 3123,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -13,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3124,
   "type": "ground"
  },
  {
   "id": 3125,
   "type": "ground"
  },
  {
   "id": 3126,
   "type": "ground"
  },
  {
   "id": 3127,
   "type": "ground"
  },
  {
   "id": 3128,
   "type": "ground"
  },
  {
   "id": 3129,
   "type": "ground"
  },
  {
   "id": 3130,
   "type": "ground"
  },
  {
   "id": 3131,
   "type": "ground"
  },
  {
   "id": 3132,
   "type": "ground"
  },
  {
   "id": 3133,
   "type": "ground"
  },
  {
   "id": 3134,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 7
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3136,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": -16
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3137,
   "type": "ground"
  },
  {
   "id": 3138,
   "type": "ground"
  },
  {
   "id": 3139,
   "type": "ground"
  },
  {
   "id": 3140,
   "type": "ground"
  },
  {
   "id": 3141,
   "type": "ground"
  },
  {
   "id": 3142,
   "type": "ground"
  },
  {
   "id": 3143,
   "type": "ground"
  },
  {
   "id": 3144,
   "type": "ground"
  },
  {
   "id": 3145,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3146,
   "type": "ground"
  },
  {
   "id": 3147,
   "type": "ground"
  },
  {
   "id": 3148,
   "type": "ground"
  },
  {
   "id": 3149,
   "type": "ground"
  },
  {
   "id": 3150,
   "type": "ground"
  },
  {
   "id": 3151,
   "type": "ground"
  },
  {
   "id": 3152,
   "type": "ground"
  },
  {
   "id": 3153,
   "type": "ground"
  },
  {
   "id": 3154,
   "type": "ground"
  },
  {
   "id": 3155,
   "type": "ground"
  },
  {
   "id": 3156,
   "type": "ground"
  },
  {
   "id": 3157,
   "type": "ground"
  },
  {
   "id": 3158,
   "type": "ground"
  },
  {
   "id": 3159,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 9,
        "y": 6
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3164,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 1
       },
       {
        "x": -8,
        "y": 7
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3165,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 14,
        "y": 5
       },
       {
        "x": 10,
        "y": 12
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 10
       },
       {
        "x": 3,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3166,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 3
       },
       {
        "x": 2,
        "y": 10
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -10,
        "y": 12
       },
       {
        "x": -14,
        "y": 5
       },
       {
        "x": -6,
        "y": 4
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3167,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 5,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3172,
   "type": "ground"
  },
  {
   "id": 3173,
   "type": "ground"
  },
  {
   "id": 3174,
   "type": "ground"
  },
  {
   "id": 3175,
   "type": "ground"
  },
  {
   "id": 3176,
   "type": "ground"
  },
  {
   "id": 3177,
   "type": "ground"
  },
  {
   "id": 3178,
   "type": "ground"
  },
  {
   "id": 3179,
   "type": "ground"
  },
  {
   "id": 3180,
   "type": "ground"
  },
  {
   "id": 3181,
   "type": "ground"
  },
  {
   "id": 3182,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3183,
   "type": "ground"
  },
  {
   "id": 3184,
   "type": "ground"
  },
  {
   "id": 3185,
   "type": "ground"
  },
  {
   "id": 3187,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 13
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 8,
        "y": 11
       },
       {
        "x": 1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3188,
   "type": "ground"
  },
  {
   "id": 3189,
   "type": "ground"
  },
  {
   "id": 3190,
   "type": "ground"
  },
  {
   "id": 3191,
   "type": "ground"
  },
  {
   "id": 3192,
   "type": "ground"
  },
  {
   "id": 3193,
   "type": "ground"
  },
  {
   "id": 3194,
   "type": "ground"
  },
  {
   "id": 3195,
   "type": "ground"
  },
  {
   "id": 3196,
   "type": "ground"
  },
  {
   "id": 3197,
   "type": "ground"
  },
  {
   "id": 3198,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": -8,
        "y": 11
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -14,
        "y": 13
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3200,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": -16
       },
       {
        "x": 10,
        "y": -16
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3201,
   "type": "ground"
  },
  {
   "id": 3202,
   "type": "ground"
  },
  {
   "id": 3203,
   "type": "ground"
  },
  {
   "id": 3204,
   "type": "ground"
  },
  {
   "id": 3205,
   "type": "ground"
  },
  {
   "id": 3206,
   "type": "ground"
  },
  {
   "id": 3207,
   "type": "ground"
  },
  {
   "id": 3208,
   "type": "ground"
  },
  {
   "id": 3209,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3210,
   "type": "ground"
  },
  {
   "id": 3211,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3218,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -11,
        "y": 2
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3219,
   "type": "ground"
  },
  {
   "id": 3220,
   "type": "ground"
  },
  {
   "id": 3221,
   "type": "ground"
  },
  {
   "id": 3222,
   "type": "ground"
  },
  {
   "id": 3223,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": -2,
        "y": 11
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3226,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 10
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -10,
        "y": 6
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3227,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -3
       },
       {
        "x": -8,
        "y": -6
       },
       {
        "x": -16,
        "y": -7
       },
       {
        "x": -16,
        "y": -10
       },
       {
        "x": -10,
        "y": -11
       },
       {
        "x": -10,
        "y": -13
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3228,
   "type": "ground"
  },
  {
   "id": 3229,
   "type": "ground"
  },
  {
   "id": 3230,
   "type": "ground"
  },
  {
   "id": 3231,
   "type": "ground"
  },
  {
   "id": 3232,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -8,
        "y": 4
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -2,
        "y": 10
       },
       {
        "x": -16,
        "y": 10
       },
       {
        "x": -16,
        "y": -1
       },
       {
        "x": -6,
        "y": -3
       },
       {
        "x": -6,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3233,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": -2
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 8,
        "y": 8
       },
       {
        "x": 3,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3236,
   "type": "ground"
  },
  {
   "id": 3237,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 16,
        "y": 4
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3238,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3239,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 3
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": -16,
        "y": 7
       },
       {
        "x": -16,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3240,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 12,
        "y": 6
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": 3,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3241,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 5,
        "y": 1
       },
       {
        "x": 15,
        "y": 6
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 13,
        "y": 13
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": 7,
        "y": 9
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3242,
   "type": "ground"
  },
  {
   "id": 3243,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 12
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3244,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 14
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -16,
        "y": 11
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3245,
   "type": "ground"
  },
  {
   "id": 3246,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 10,
        "y": 8
       },
       {
        "x": 2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3247,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 4
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -14,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3248,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3249,
   "type": "ground"
  },
  {
   "id": 3250,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -5,
        "y": 8
       },
       {
        "x": -5,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3251,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3252,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3253,
   "type": "ground"
  },
  {
   "id": 3254,
   "type": "ground"
  },
  {
   "id": 3255,
   "type": "ground"
  },
  {
   "id": 3256,
   "type": "ground"
  },
  {
   "id": 3257,
   "type": "ground"
  },
  {
   "id": 3258,
   "type": "ground"
  },
  {
   "id": 3259,
   "type": "ground"
  },
  {
   "id": 3260,
   "type": "ground"
  },
  {
   "id": 3261,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3262,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3263,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 2
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3264,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 0
       },
       {
        "x": 10,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3265,
   "type": "ground"
  },
  {
   "id": 3266,
   "type": "ground"
  },
  {
   "id": 3267,
   "type": "ground"
  },
  {
   "id": 3268,
   "type": "ground"
  },
  {
   "id": 3269,
   "type": "ground"
  },
  {
   "id": 3270,
   "type": "ground"
  },
  {
   "id": 3271,
   "type": "ground"
  },
  {
   "id": 3272,
   "type": "ground"
  },
  {
   "id": 3273,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3274,
   "type": "ground"
  },
  {
   "id": 3275,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3282,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3283,
   "type": "ground"
  },
  {
   "id": 3284,
   "type": "ground"
  },
  {
   "id": 3285,
   "type": "ground"
  },
  {
   "id": 3286,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3287,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -6,
        "y": 3
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3290,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -6,
        "y": 2
       },
       {
        "x": -5,
        "y": 6
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -14,
        "y": 15
       },
       {
        "x": -15,
        "y": 8
       },
       {
        "x": -8,
        "y": 5
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3291,
   "type": "ground"
  },
  {
   "id": 3292,
   "type": "ground"
  },
  {
   "id": 3293,
   "type": "ground"
  },
  {
   "id": 3294,
   "type": "ground"
  },
  {
   "id": 3295,
   "type": "ground"
  },
  {
   "id": 3296,
   "type": "ground"
  },
  {
   "id": 3297,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": 0
       },
       {
        "x": -14,
        "y": -6
       },
       {
        "x": -8,
        "y": -11
       },
       {
        "x": -8,
        "y": -13
       },
       {
        "x": -14,
        "y": -15
       },
       {
        "x": -5,
        "y": -15
       },
       {
        "x": -6,
        "y": -10
       },
       {
        "x": 1,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3300,
   "type": "ground"
  },
  {
   "id": 3301,
   "type": "ground"
  },
  {
   "id": 3302,
   "type": "ground"
  },
  {
   "id": 3303,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 5
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3304,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": 9,
        "y": 7
       },
       {
        "x": 6,
        "y": 5
       },
       {
        "x": 8,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3305,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 7
       },
       {
        "x": -13,
        "y": 7
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3308,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 3,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3309,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 8
       },
       {
        "x": -14,
        "y": 4
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3310,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3311,
   "type": "ground"
  },
  {
   "id": 3312,
   "type": "ground"
  },
  {
   "id": 3313,
   "type": "ground"
  },
  {
   "id": 3314,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 5,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3315,
   "type": "ground"
  },
  {
   "id": 3316,
   "type": "ground"
  },
  {
   "id": 3317,
   "type": "ground"
  },
  {
   "id": 3318,
   "type": "ground"
  },
  {
   "id": 3319,
   "type": "ground"
  },
  {
   "id": 3320,
   "type": "ground"
  },
  {
   "id": 3321,
   "type": "ground"
  },
  {
   "id": 3322,
   "type": "ground"
  },
  {
   "id": 3323,
   "type": "ground"
  },
  {
   "id": 3324,
   "type": "ground"
  },
  {
   "id": 3325,
   "type": "ground"
  },
  {
   "id": 3326,
   "type": "ground"
  },
  {
   "id": 3327,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -6,
        "y": 5
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3328,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 3,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3329,
   "type": "ground"
  },
  {
   "id": 3330,
   "type": "ground"
  },
  {
   "id": 3331,
   "type": "ground"
  },
  {
   "id": 3332,
   "type": "ground"
  },
  {
   "id": 3333,
   "type": "ground"
  },
  {
   "id": 3334,
   "type": "ground"
  },
  {
   "id": 3335,
   "type": "ground"
  },
  {
   "id": 3336,
   "type": "ground"
  },
  {
   "id": 3337,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 5
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3338,
   "type": "ground"
  },
  {
   "id": 3339,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 9,
        "y": 4
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3342,
   "type": "ground"
  },
  {
   "id": 3343,
   "type": "ground"
  },
  {
   "id": 3346,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -9,
        "y": 4
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3347,
   "type": "ground"
  },
  {
   "id": 3348,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3349,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3350,
   "type": "ground"
  },
  {
   "id": 3351,
   "type": "ground"
  },
  {
   "id": 3353,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -13,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3354,
   "type": "ground"
  },
  {
   "id": 3355,
   "type": "ground"
  },
  {
   "id": 3356,
   "type": "ground"
  },
  {
   "id": 3357,
   "type": "ground"
  },
  {
   "id": 3358,
   "type": "ground"
  },
  {
   "id": 3359,
   "type": "ground"
  },
  {
   "id": 3360,
   "type": "ground"
  },
  {
   "id": 3361,
   "type": "ground"
  },
  {
   "id": 3362,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 7
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3364,
   "type": "ground"
  },
  {
   "id": 3365,
   "type": "ground"
  },
  {
   "id": 3366,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3375,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -14,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3376,
   "type": "ground"
  },
  {
   "id": 3377,
   "type": "ground"
  },
  {
   "id": 3379,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -14,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3380,
   "type": "ground"
  },
  {
   "id": 3381,
   "type": "ground"
  },
  {
   "id": 3382,
   "type": "ground"
  },
  {
   "id": 3383,
   "type": "ground"
  },
  {
   "id": 3384,
   "type": "ground"
  },
  {
   "id": 3385,
   "type": "ground"
  },
  {
   "id": 3386,
   "type": "ground"
  },
  {
   "id": 3387,
   "type": "ground"
  },
  {
   "id": 3388,
   "type": "ground"
  },
  {
   "id": 3389,
   "type": "ground"
  },
  {
   "id": 3390,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 8
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3392,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -16
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3393,
   "type": "ground"
  },
  {
   "id": 3394,
   "type": "ground"
  },
  {
   "id": 3395,
   "type": "ground"
  },
  {
   "id": 3396,
   "type": "ground"
  },
  {
   "id": 3397,
   "type": "ground"
  },
  {
   "id": 3398,
   "type": "ground"
  },
  {
   "id": 3399,
   "type": "ground"
  },
  {
   "id": 3400,
   "type": "ground"
  },
  {
   "id": 3401,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3402,
   "type": "ground"
  },
  {
   "id": 3403,
   "type": "ground"
  },
  {
   "id": 3406,
   "type": "ground"
  },
  {
   "id": 3407,
   "type": "ground"
  },
  {
   "id": 3410,
   "type": "ground"
  },
  {
   "id": 3411,
   "type": "ground"
  },
  {
   "id": 3412,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -9,
        "y": 6
       },
       {
        "x": -6,
        "y": 4
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3413,
   "type": "ground"
  },
  {
   "id": 3414,
   "type": "ground"
  },
  {
   "id": 3415,
   "type": "ground"
  },
  {
   "id": 3417,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 13
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 8,
        "y": 11
       },
       {
        "x": 1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3418,
   "type": "ground"
  },
  {
   "id": 3419,
   "type": "ground"
  },
  {
   "id": 3420,
   "type": "ground"
  },
  {
   "id": 3421,
   "type": "ground"
  },
  {
   "id": 3422,
   "type": "ground"
  },
  {
   "id": 3423,
   "type": "ground"
  },
  {
   "id": 3424,
   "type": "ground"
  },
  {
   "id": 3425,
   "type": "ground"
  },
  {
   "id": 3426,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": -8,
        "y": 11
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -14,
        "y": 13
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3428,
   "type": "ground"
  },
  {
   "id": 3429,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 13
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3430,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": -4
       },
       {
        "x": -2,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3431,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 3
       },
       {
        "x": -3,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3438,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": -3
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3439,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": -7
       },
       {
        "x": -14,
        "y": -12
       },
       {
        "x": -11,
        "y": -16
       },
       {
        "x": 2,
        "y": -16
       },
       {
        "x": 2,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3440,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 0,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3441,
   "type": "ground"
  },
  {
   "id": 3442,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": -3
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3443,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -14,
        "y": -7
       },
       {
        "x": -14,
        "y": -12
       },
       {
        "x": -11,
        "y": -16
       },
       {
        "x": 2,
        "y": -16
       },
       {
        "x": 2,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3444,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 0,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3445,
   "type": "ground"
  },
  {
   "id": 3446,
   "type": "ground"
  },
  {
   "id": 3447,
   "type": "ground"
  },
  {
   "id": 3448,
   "type": "ground"
  },
  {
   "id": 3449,
   "type": "ground"
  },
  {
   "id": 3450,
   "type": "ground"
  },
  {
   "id": 3451,
   "type": "ground"
  },
  {
   "id": 3452,
   "type": "ground"
  },
  {
   "id": 3453,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 13
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3454,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -16,
        "y": -4
       },
       {
        "x": -2,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3455,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 3
       },
       {
        "x": -3,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3456,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -16
       },
       {
        "x": 13,
        "y": -16
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3457,
   "type": "ground"
  },
  {
   "id": 3458,
   "type": "ground"
  },
  {
   "id": 3459,
   "type": "ground"
  },
  {
   "id": 3460,
   "type": "ground"
  },
  {
   "id": 3461,
   "type": "ground"
  },
  {
   "id": 3462,
   "type": "ground"
  },
  {
   "id": 3463,
   "type": "ground"
  },
  {
   "id": 3464,
   "type": "ground"
  },
  {
   "id": 3465,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3466,
   "type": "ground"
  },
  {
   "id": 3467,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 9,
        "y": 7
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3474,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3475,
   "type": "ground"
  },
  {
   "id": 3476,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": 2,
        "y": 11
       },
       {
        "x": -1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3477,
   "type": "ground"
  },
  {
   "id": 3478,
   "type": "ground"
  },
  {
   "id": 3479,
   "type": "ground"
  },
  {
   "id": 3481,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 2
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -4,
        "y": 4
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3482,
   "type": "ground"
  },
  {
   "id": 3483,
   "type": "ground"
  },
  {
   "id": 3484,
   "type": "ground"
  },
  {
   "id": 3485,
   "type": "ground"
  },
  {
   "id": 3486,
   "type": "ground"
  },
  {
   "id": 3487,
   "type": "ground"
  },
  {
   "id": 3488,
   "type": "ground"
  },
  {
   "id": 3489,
   "type": "ground"
  },
  {
   "id": 3490,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 4,
        "y": 4
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3492,
   "type": "ground"
  },
  {
   "id": 3493,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3494,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3495,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 3
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3496,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -7
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3497,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 7
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3500,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 12,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 4
       },
       {
        "x": -10,
        "y": 4
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3501,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -14,
        "y": -4
       },
       {
        "x": -7,
        "y": -8
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3502,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -3
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3503,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3504,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3505,
   "type": "ground"
  },
  {
   "id": 3507,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3508,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3509,
   "type": "ground"
  },
  {
   "id": 3510,
   "type": "ground"
  },
  {
   "id": 3511,
   "type": "ground"
  },
  {
   "id": 3512,
   "type": "ground"
  },
  {
   "id": 3513,
   "type": "ground"
  },
  {
   "id": 3514,
   "type": "ground"
  },
  {
   "id": 3515,
   "type": "ground"
  },
  {
   "id": 3516,
   "type": "ground"
  },
  {
   "id": 3517,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3518,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3520,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3521,
   "type": "ground"
  },
  {
   "id": 3522,
   "type": "ground"
  },
  {
   "id": 3523,
   "type": "ground"
  },
  {
   "id": 3524,
   "type": "ground"
  },
  {
   "id": 3525,
   "type": "ground"
  },
  {
   "id": 3526,
   "type": "ground"
  },
  {
   "id": 3527,
   "type": "ground"
  },
  {
   "id": 3528,
   "type": "ground"
  },
  {
   "id": 3529,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3530,
   "type": "ground"
  },
  {
   "id": 3531,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3538,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3539,
   "type": "ground"
  },
  {
   "id": 3540,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3541,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 3,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 13
       },
       {
        "x": 16,
        "y": -3
       },
       {
        "x": 0,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3542,
   "type": "ground"
  },
  {
   "id": 3543,
   "type": "ground"
  },
  {
   "id": 3545,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3546,
   "type": "ground"
  },
  {
   "id": 3547,
   "type": "ground"
  },
  {
   "id": 3548,
   "type": "ground"
  },
  {
   "id": 3549,
   "type": "ground"
  },
  {
   "id": 3550,
   "type": "ground"
  },
  {
   "id": 3551,
   "type": "ground"
  },
  {
   "id": 3552,
   "type": "ground"
  },
  {
   "id": 3553,
   "type": "ground"
  },
  {
   "id": 3554,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 3
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3556,
   "type": "ground"
  },
  {
   "id": 3557,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3558,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 6
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3559,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 1
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -11,
        "y": -1
       },
       {
        "x": -9,
        "y": -5
       },
       {
        "x": -4,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3560,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -6
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3561,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 4
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3562,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -7,
        "y": 6
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -16,
        "y": 4
       },
       {
        "x": -10,
        "y": 3
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3563,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 2
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 4,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3564,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -12,
        "y": 0
       },
       {
        "x": -16,
        "y": -11
       },
       {
        "x": -10,
        "y": -16
       },
       {
        "x": 0,
        "y": -14
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3565,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 2
       },
       {
        "x": 2,
        "y": 8
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -14,
        "y": 2
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3566,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": -1
       },
       {
        "x": -16,
        "y": -4
       },
       {
        "x": -12,
        "y": -9
       },
       {
        "x": -6,
        "y": -9
       },
       {
        "x": -5,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3567,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": -1,
        "y": 9
       },
       {
        "x": 2,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3568,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3569,
   "type": "ground"
  },
  {
   "id": 3571,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 14
       },
       {
        "x": 16,
        "y": -2
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3572,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3573,
   "type": "ground"
  },
  {
   "id": 3574,
   "type": "ground"
  },
  {
   "id": 3575,
   "type": "ground"
  },
  {
   "id": 3576,
   "type": "ground"
  },
  {
   "id": 3577,
   "type": "ground"
  },
  {
   "id": 3578,
   "type": "ground"
  },
  {
   "id": 3579,
   "type": "ground"
  },
  {
   "id": 3580,
   "type": "ground"
  },
  {
   "id": 3581,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3582,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -14
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3584,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": -1,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3585,
   "type": "ground"
  },
  {
   "id": 3586,
   "type": "ground"
  },
  {
   "id": 3587,
   "type": "ground"
  },
  {
   "id": 3588,
   "type": "ground"
  },
  {
   "id": 3589,
   "type": "ground"
  },
  {
   "id": 3590,
   "type": "ground"
  },
  {
   "id": 3591,
   "type": "ground"
  },
  {
   "id": 3592,
   "type": "ground"
  },
  {
   "id": 3593,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3594,
   "type": "ground"
  },
  {
   "id": 3595,
   "type": "ground"
  },
  {
   "id": 3596,
   "type": "ground"
  },
  {
   "id": 3597,
   "type": "ground"
  },
  {
   "id": 3598,
   "type": "ground"
  },
  {
   "id": 3599,
   "type": "ground"
  },
  {
   "id": 3600,
   "type": "ground"
  },
  {
   "id": 3601,
   "type": "ground"
  },
  {
   "id": 3602,
   "type": "ground"
  },
  {
   "id": 3603,
   "type": "ground"
  },
  {
   "id": 3610,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 5
       },
       {
        "x": 8,
        "y": 10
       },
       {
        "x": 8,
        "y": 12
       },
       {
        "x": 14,
        "y": 13
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 6,
        "y": 9
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3611,
   "type": "ground"
  },
  {
   "id": 3612,
   "type": "ground"
  },
  {
   "id": 3613,
   "type": "ground"
  },
  {
   "id": 3614,
   "type": "ground"
  },
  {
   "id": 3615,
   "type": "ground"
  },
  {
   "id": 3616,
   "type": "ground"
  },
  {
   "id": 3617,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 6
       },
       {
        "x": -6,
        "y": 9
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -14,
        "y": 13
       },
       {
        "x": -8,
        "y": 12
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -14,
        "y": 5
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3620,
   "type": "ground"
  },
  {
   "id": 3621,
   "type": "ground"
  },
  {
   "id": 3622,
   "type": "ground"
  },
  {
   "id": 3623,
   "type": "ground"
  },
  {
   "id": 3624,
   "type": "ground"
  },
  {
   "id": 3625,
   "type": "ground"
  },
  {
   "id": 3626,
   "type": "ground"
  },
  {
   "id": 3627,
   "type": "ground"
  },
  {
   "id": 3628,
   "type": "ground"
  },
  {
   "id": 3629,
   "type": "ground"
  },
  {
   "id": 3630,
   "type": "ground"
  },
  {
   "id": 3631,
   "type": "ground"
  },
  {
   "id": 3632,
   "type": "ground"
  },
  {
   "id": 3633,
   "type": "ground"
  },
  {
   "id": 3635,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 2
       },
       {
        "x": 2,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -11,
        "y": 6
       },
       {
        "x": -4,
        "y": 4
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3636,
   "type": "ground"
  },
  {
   "id": 3637,
   "type": "ground"
  },
  {
   "id": 3638,
   "type": "ground"
  },
  {
   "id": 3639,
   "type": "ground"
  },
  {
   "id": 3640,
   "type": "ground"
  },
  {
   "id": 3641,
   "type": "ground"
  },
  {
   "id": 3642,
   "type": "ground"
  },
  {
   "id": 3643,
   "type": "ground"
  },
  {
   "id": 3644,
   "type": "ground"
  },
  {
   "id": 3645,
   "type": "ground"
  },
  {
   "id": 3646,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 4,
        "y": 4
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -2,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3648,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 7
       },
       {
        "x": 1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3649,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 0,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3650,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -16,
        "y": 14
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3651,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 15
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3652,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": -16,
        "y": 15
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3653,
   "type": "ground"
  },
  {
   "id": 3654,
   "type": "ground"
  },
  {
   "id": 3655,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 14
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3656,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3657,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": -3,
        "y": 7
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3658,
   "type": "ground"
  },
  {
   "id": 3659,
   "type": "ground"
  },
  {
   "id": 3660,
   "type": "ground"
  },
  {
   "id": 3661,
   "type": "ground"
  },
  {
   "id": 3662,
   "type": "ground"
  },
  {
   "id": 3663,
   "type": "ground"
  },
  {
   "id": 3664,
   "type": "ground"
  },
  {
   "id": 3665,
   "type": "ground"
  },
  {
   "id": 3666,
   "type": "ground"
  },
  {
   "id": 3667,
   "type": "ground"
  },
  {
   "id": 3674,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 8,
        "y": 10
       },
       {
        "x": 4,
        "y": 10
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": -2,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3675,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 10
       },
       {
        "x": -10,
        "y": 13
       },
       {
        "x": -10,
        "y": 10
       },
       {
        "x": -16,
        "y": 10
       },
       {
        "x": -16,
        "y": 6
       },
       {
        "x": -8,
        "y": 5
       },
       {
        "x": -13,
        "y": 3
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3676,
   "type": "ground"
  },
  {
   "id": 3677,
   "type": "ground"
  },
  {
   "id": 3678,
   "type": "ground"
  },
  {
   "id": 3679,
   "type": "ground"
  },
  {
   "id": 3680,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 13,
        "y": 3
       },
       {
        "x": 8,
        "y": 5
       },
       {
        "x": 16,
        "y": 6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 10,
        "y": 10
       },
       {
        "x": 10,
        "y": 13
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3681,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 3
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -4,
        "y": 10
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3684,
   "type": "ground"
  },
  {
   "id": 3685,
   "type": "ground"
  },
  {
   "id": 3686,
   "type": "ground"
  },
  {
   "id": 3687,
   "type": "ground"
  },
  {
   "id": 3688,
   "type": "ground"
  },
  {
   "id": 3689,
   "type": "ground"
  },
  {
   "id": 3690,
   "type": "ground"
  },
  {
   "id": 3691,
   "type": "ground"
  },
  {
   "id": 3692,
   "type": "ground"
  },
  {
   "id": 3693,
   "type": "ground"
  },
  {
   "id": 3694,
   "type": "ground"
  },
  {
   "id": 3695,
   "type": "ground"
  },
  {
   "id": 3696,
   "type": "ground"
  },
  {
   "id": 3697,
   "type": "ground"
  },
  {
   "id": 3699,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3700,
   "type": "ground"
  },
  {
   "id": 3701,
   "type": "ground"
  },
  {
   "id": 3702,
   "type": "ground"
  },
  {
   "id": 3703,
   "type": "ground"
  },
  {
   "id": 3704,
   "type": "ground"
  },
  {
   "id": 3705,
   "type": "ground"
  },
  {
   "id": 3706,
   "type": "ground"
  },
  {
   "id": 3707,
   "type": "ground"
  },
  {
   "id": 3708,
   "type": "ground"
  },
  {
   "id": 3709,
   "type": "ground"
  },
  {
   "id": 3710,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 3
       },
       {
        "x": -14,
        "y": 11
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3740,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 6
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 8,
        "y": 13
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 5,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3741,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 3
       },
       {
        "x": 3,
        "y": 10
       },
       {
        "x": -5,
        "y": 11
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -8,
        "y": 12
       },
       {
        "x": -13,
        "y": 6
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3742,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 6
       },
       {
        "x": 8,
        "y": 12
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 5,
        "y": 11
       },
       {
        "x": -3,
        "y": 10
       },
       {
        "x": 1,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3743,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -5,
        "y": 9
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -9,
        "y": 14
       },
       {
        "x": -6,
        "y": 8
       },
       {
        "x": -13,
        "y": 6
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3764,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 6
       },
       {
        "x": 11,
        "y": 8
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3765,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 4
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 5,
        "y": 13
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3766,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 15,
        "y": 4
       },
       {
        "x": 12,
        "y": 6
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": -1,
        "y": 10
       },
       {
        "x": -1,
        "y": 6
       },
       {
        "x": 3,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3767,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 5,
        "y": 1
       },
       {
        "x": 15,
        "y": 6
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 13,
        "y": 13
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": 7,
        "y": 9
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3768,
   "type": "ground"
  },
  {
   "id": 3769,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 12
       },
       {
        "x": -8,
        "y": 10
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3770,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 14
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -16,
        "y": 11
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3771,
   "type": "ground"
  },
  {
   "id": 3772,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -5,
        "y": 13
       },
       {
        "x": -16,
        "y": 9
       },
       {
        "x": -13,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3773,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 3
       },
       {
        "x": -6,
        "y": 8
       },
       {
        "x": -11,
        "y": 8
       },
       {
        "x": -14,
        "y": 6
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3830,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": 9,
        "y": 7
       },
       {
        "x": 6,
        "y": 5
       },
       {
        "x": 8,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3831,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 7
       },
       {
        "x": -13,
        "y": 7
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3834,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 10,
        "y": 4
       },
       {
        "x": 3,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3835,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 8
       },
       {
        "x": -14,
        "y": 4
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3840,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 5
       },
       {
        "x": -8,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3841,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 8,
        "y": 2
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 6,
        "y": 5
       },
       {
        "x": 7,
        "y": 3
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3842,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3843,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3844,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -15,
        "y": 13
       },
       {
        "x": -6,
        "y": 12
       },
       {
        "x": -10,
        "y": 5
       },
       {
        "x": -7,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3845,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3846,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 15,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 1
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3847,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -15,
        "y": -2
       },
       {
        "x": -15,
        "y": -5
       },
       {
        "x": -10,
        "y": -8
       },
       {
        "x": -4,
        "y": -8
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3848,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3849,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -5
       },
       {
        "x": -11,
        "y": -8
       },
       {
        "x": -5,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3852,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3853,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3856,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -6,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3857,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -2
       },
       {
        "x": -4,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3858,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3859,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3860,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -15,
        "y": 13
       },
       {
        "x": -6,
        "y": 12
       },
       {
        "x": -10,
        "y": 5
       },
       {
        "x": -7,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3861,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3862,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 15,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 1
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3863,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -15,
        "y": -2
       },
       {
        "x": -15,
        "y": -5
       },
       {
        "x": -10,
        "y": -8
       },
       {
        "x": -4,
        "y": -8
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3864,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3865,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3866,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -2,
        "y": 7
       },
       {
        "x": -2,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3867,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 7,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 9
     }
    ]
   }
  },
  {
   "id": 3868,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 9,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 2
       },
       {
        "x": 6,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3870,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -2,
        "y": 11
       },
       {
        "x": -2,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3871,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 12,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 4
     }
    ]
   }
  },
  {
   "id": 3872,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 2
       },
       {
        "x": 10,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3874,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 5
       },
       {
        "x": -8,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3875,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 8,
        "y": 2
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 6,
        "y": 5
       },
       {
        "x": 7,
        "y": 3
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3876,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3877,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3878,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -15,
        "y": 13
       },
       {
        "x": -6,
        "y": 12
       },
       {
        "x": -10,
        "y": 5
       },
       {
        "x": -7,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3879,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3880,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 15,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 1
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3881,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -15,
        "y": -2
       },
       {
        "x": -15,
        "y": -5
       },
       {
        "x": -10,
        "y": -8
       },
       {
        "x": -4,
        "y": -8
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3882,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3883,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -5
       },
       {
        "x": -11,
        "y": -8
       },
       {
        "x": -5,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3886,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3887,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3890,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -6,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3891,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -16,
        "y": 0
       },
       {
        "x": -16,
        "y": -2
       },
       {
        "x": -4,
        "y": -3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3892,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3893,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3894,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -15,
        "y": 13
       },
       {
        "x": -6,
        "y": 12
       },
       {
        "x": -10,
        "y": 5
       },
       {
        "x": -7,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3895,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3896,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 15,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 1
       },
       {
        "x": -5,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3897,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -11,
        "y": 0
       },
       {
        "x": -15,
        "y": -2
       },
       {
        "x": -15,
        "y": -5
       },
       {
        "x": -10,
        "y": -8
       },
       {
        "x": -4,
        "y": -8
       },
       {
        "x": 0,
        "y": -4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3898,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -12,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3899,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3904,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -2,
        "y": 7
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": 1,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -9,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3905,
   "type": "ground"
  },
  {
   "id": 3906,
   "type": "ground"
  },
  {
   "id": 3907,
   "type": "ground"
  },
  {
   "id": 3908,
   "type": "ground"
  },
  {
   "id": 3909,
   "type": "ground"
  },
  {
   "id": 3910,
   "type": "ground"
  },
  {
   "id": 3911,
   "type": "ground"
  },
  {
   "id": 3912,
   "type": "ground"
  },
  {
   "id": 3913,
   "type": "ground"
  },
  {
   "id": 3914,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3916,
   "type": "ground"
  },
  {
   "id": 3917,
   "type": "ground"
  },
  {
   "id": 3918,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -13,
        "y": 12
       },
       {
        "x": -12,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3919,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 1
       },
       {
        "x": 13,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3920,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": -3,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3921,
   "type": "ground"
  },
  {
   "id": 3922,
   "type": "ground"
  },
  {
   "id": 3923,
   "type": "ground"
  },
  {
   "id": 3924,
   "type": "ground"
  },
  {
   "id": 3925,
   "type": "ground"
  },
  {
   "id": 3926,
   "type": "ground"
  },
  {
   "id": 3927,
   "type": "ground"
  },
  {
   "id": 3928,
   "type": "ground"
  },
  {
   "id": 3929,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 9
       },
       {
        "x": -5,
        "y": 11
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3930,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 4,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 2,
      "x": 14,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 3931,
   "type": "ground"
  },
  {
   "id": 3932,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 15
       },
       {
        "x": -10,
        "y": 15
       },
       {
        "x": -10,
        "y": -1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3935,
   "type": "ground"
  },
  {
   "id": 3936,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3938,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 5
       },
       {
        "x": -2,
        "y": 7
       },
       {
        "x": 1,
        "y": 9
       },
       {
        "x": 1,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -9,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3939,
   "type": "ground"
  },
  {
   "id": 3940,
   "type": "ground"
  },
  {
   "id": 3941,
   "type": "ground"
  },
  {
   "id": 3942,
   "type": "ground"
  },
  {
   "id": 3943,
   "type": "ground"
  },
  {
   "id": 3944,
   "type": "ground"
  },
  {
   "id": 3945,
   "type": "ground"
  },
  {
   "id": 3946,
   "type": "ground"
  },
  {
   "id": 3947,
   "type": "ground"
  },
  {
   "id": 3948,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3950,
   "type": "ground"
  },
  {
   "id": 3951,
   "type": "ground"
  },
  {
   "id": 3952,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 12
       },
       {
        "x": -13,
        "y": 12
       },
       {
        "x": -12,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3953,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 1
       },
       {
        "x": 13,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3954,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": -3,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3955,
   "type": "ground"
  },
  {
   "id": 3956,
   "type": "ground"
  },
  {
   "id": 3957,
   "type": "ground"
  },
  {
   "id": 3958,
   "type": "ground"
  },
  {
   "id": 3959,
   "type": "ground"
  },
  {
   "id": 3960,
   "type": "ground"
  },
  {
   "id": 3961,
   "type": "ground"
  },
  {
   "id": 3962,
   "type": "ground"
  },
  {
   "id": 3963,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 9
       },
       {
        "x": -5,
        "y": 11
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3968,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3969,
   "type": "ground"
  },
  {
   "id": 3970,
   "type": "ground"
  },
  {
   "id": 3971,
   "type": "ground"
  },
  {
   "id": 3972,
   "type": "ground"
  },
  {
   "id": 3973,
   "type": "ground"
  },
  {
   "id": 3974,
   "type": "ground"
  },
  {
   "id": 3975,
   "type": "ground"
  },
  {
   "id": 3976,
   "type": "ground"
  },
  {
   "id": 3977,
   "type": "ground"
  },
  {
   "id": 3978,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3980,
   "type": "ground"
  },
  {
   "id": 3981,
   "type": "ground"
  },
  {
   "id": 3982,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3983,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3984,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 10,
        "y": 11
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3985,
   "type": "ground"
  },
  {
   "id": 3986,
   "type": "ground"
  },
  {
   "id": 3987,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3988,
   "type": "ground"
  },
  {
   "id": 3989,
   "type": "ground"
  },
  {
   "id": 3990,
   "type": "ground"
  },
  {
   "id": 3991,
   "type": "ground"
  },
  {
   "id": 3992,
   "type": "ground"
  },
  {
   "id": 3993,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -10,
        "y": 11
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3995,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3996,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 9,
        "y": 12
       },
       {
        "x": 12,
        "y": 13
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 3999,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4000,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4002,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4003,
   "type": "ground"
  },
  {
   "id": 4004,
   "type": "ground"
  },
  {
   "id": 4005,
   "type": "ground"
  },
  {
   "id": 4006,
   "type": "ground"
  },
  {
   "id": 4007,
   "type": "ground"
  },
  {
   "id": 4008,
   "type": "ground"
  },
  {
   "id": 4009,
   "type": "ground"
  },
  {
   "id": 4010,
   "type": "ground"
  },
  {
   "id": 4011,
   "type": "ground"
  },
  {
   "id": 4012,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4014,
   "type": "ground"
  },
  {
   "id": 4015,
   "type": "ground"
  },
  {
   "id": 4016,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4017,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4018,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 10,
        "y": 11
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4019,
   "type": "ground"
  },
  {
   "id": 4020,
   "type": "ground"
  },
  {
   "id": 4021,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4022,
   "type": "ground"
  },
  {
   "id": 4023,
   "type": "ground"
  },
  {
   "id": 4024,
   "type": "ground"
  },
  {
   "id": 4025,
   "type": "ground"
  },
  {
   "id": 4026,
   "type": "ground"
  },
  {
   "id": 4027,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 4
       },
       {
        "x": -10,
        "y": 11
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4032,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4033,
   "type": "ground"
  },
  {
   "id": 4034,
   "type": "ground"
  },
  {
   "id": 4035,
   "type": "ground"
  },
  {
   "id": 4036,
   "type": "ground"
  },
  {
   "id": 4037,
   "type": "ground"
  },
  {
   "id": 4038,
   "type": "ground"
  },
  {
   "id": 4039,
   "type": "ground"
  },
  {
   "id": 4040,
   "type": "ground"
  },
  {
   "id": 4041,
   "type": "ground"
  },
  {
   "id": 4042,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4044,
   "type": "ground"
  },
  {
   "id": 4045,
   "type": "ground"
  },
  {
   "id": 4046,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4047,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4048,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": -3,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4049,
   "type": "ground"
  },
  {
   "id": 4050,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 12,
        "y": 5
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4051,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 7
       },
       {
        "x": -8,
        "y": 6
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4052,
   "type": "ground"
  },
  {
   "id": 4053,
   "type": "ground"
  },
  {
   "id": 4054,
   "type": "ground"
  },
  {
   "id": 4055,
   "type": "ground"
  },
  {
   "id": 4056,
   "type": "ground"
  },
  {
   "id": 4057,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 9
       },
       {
        "x": -5,
        "y": 12
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4059,
   "type": "ground"
  },
  {
   "id": 4060,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4063,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4064,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4066,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4067,
   "type": "ground"
  },
  {
   "id": 4068,
   "type": "ground"
  },
  {
   "id": 4069,
   "type": "ground"
  },
  {
   "id": 4070,
   "type": "ground"
  },
  {
   "id": 4071,
   "type": "ground"
  },
  {
   "id": 4072,
   "type": "ground"
  },
  {
   "id": 4073,
   "type": "ground"
  },
  {
   "id": 4074,
   "type": "ground"
  },
  {
   "id": 4075,
   "type": "ground"
  },
  {
   "id": 4076,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4078,
   "type": "ground"
  },
  {
   "id": 4079,
   "type": "ground"
  },
  {
   "id": 4080,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4081,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4082,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 0
       },
       {
        "x": 4,
        "y": 12
       },
       {
        "x": -3,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4083,
   "type": "ground"
  },
  {
   "id": 4084,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 12,
        "y": 5
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4085,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 7
       },
       {
        "x": -8,
        "y": 6
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4086,
   "type": "ground"
  },
  {
   "id": 4087,
   "type": "ground"
  },
  {
   "id": 4088,
   "type": "ground"
  },
  {
   "id": 4089,
   "type": "ground"
  },
  {
   "id": 4090,
   "type": "ground"
  },
  {
   "id": 4091,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 9
       },
       {
        "x": -5,
        "y": 12
       },
       {
        "x": -5,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4096,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4097,
   "type": "ground"
  },
  {
   "id": 4098,
   "type": "ground"
  },
  {
   "id": 4099,
   "type": "ground"
  },
  {
   "id": 4100,
   "type": "ground"
  },
  {
   "id": 4101,
   "type": "ground"
  },
  {
   "id": 4102,
   "type": "ground"
  },
  {
   "id": 4103,
   "type": "ground"
  },
  {
   "id": 4104,
   "type": "ground"
  },
  {
   "id": 4105,
   "type": "ground"
  },
  {
   "id": 4106,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4108,
   "type": "ground"
  },
  {
   "id": 4109,
   "type": "ground"
  },
  {
   "id": 4110,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4111,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4112,
   "type": "ground"
  },
  {
   "id": 4113,
   "type": "ground"
  },
  {
   "id": 4114,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4115,
   "type": "ground"
  },
  {
   "id": 4116,
   "type": "ground"
  },
  {
   "id": 4117,
   "type": "ground"
  },
  {
   "id": 4118,
   "type": "ground"
  },
  {
   "id": 4119,
   "type": "ground"
  },
  {
   "id": 4120,
   "type": "ground"
  },
  {
   "id": 4121,
   "type": "ground"
  },
  {
   "id": 4123,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -4
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4124,
   "type": "ground"
  },
  {
   "id": 4127,
   "type": "ground"
  },
  {
   "id": 4128,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4130,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4131,
   "type": "ground"
  },
  {
   "id": 4132,
   "type": "ground"
  },
  {
   "id": 4133,
   "type": "ground"
  },
  {
   "id": 4134,
   "type": "ground"
  },
  {
   "id": 4135,
   "type": "ground"
  },
  {
   "id": 4136,
   "type": "ground"
  },
  {
   "id": 4137,
   "type": "ground"
  },
  {
   "id": 4138,
   "type": "ground"
  },
  {
   "id": 4139,
   "type": "ground"
  },
  {
   "id": 4140,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4142,
   "type": "ground"
  },
  {
   "id": 4143,
   "type": "ground"
  },
  {
   "id": 4144,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4145,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4146,
   "type": "ground"
  },
  {
   "id": 4147,
   "type": "ground"
  },
  {
   "id": 4148,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -10
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4149,
   "type": "ground"
  },
  {
   "id": 4150,
   "type": "ground"
  },
  {
   "id": 4151,
   "type": "ground"
  },
  {
   "id": 4152,
   "type": "ground"
  },
  {
   "id": 4153,
   "type": "ground"
  },
  {
   "id": 4154,
   "type": "ground"
  },
  {
   "id": 4155,
   "type": "ground"
  },
  {
   "id": 4160,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -15,
        "y": 6
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4161,
   "type": "ground"
  },
  {
   "id": 4162,
   "type": "ground"
  },
  {
   "id": 4163,
   "type": "ground"
  },
  {
   "id": 4164,
   "type": "ground"
  },
  {
   "id": 4165,
   "type": "ground"
  },
  {
   "id": 4166,
   "type": "ground"
  },
  {
   "id": 4167,
   "type": "ground"
  },
  {
   "id": 4168,
   "type": "ground"
  },
  {
   "id": 4169,
   "type": "ground"
  },
  {
   "id": 4170,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4172,
   "type": "ground"
  },
  {
   "id": 4173,
   "type": "ground"
  },
  {
   "id": 4174,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -15,
        "y": 6
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4175,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 15,
        "y": 5
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4176,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -6,
        "y": 8
       },
       {
        "x": -6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4177,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4178,
   "type": "ground"
  },
  {
   "id": 4179,
   "type": "ground"
  },
  {
   "id": 4180,
   "type": "ground"
  },
  {
   "id": 4181,
   "type": "ground"
  },
  {
   "id": 4182,
   "type": "ground"
  },
  {
   "id": 4183,
   "type": "ground"
  },
  {
   "id": 4184,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4185,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 3
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4187,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4188,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4191,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       },
       {
        "x": 2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4192,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4194,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -15,
        "y": 6
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4195,
   "type": "ground"
  },
  {
   "id": 4196,
   "type": "ground"
  },
  {
   "id": 4197,
   "type": "ground"
  },
  {
   "id": 4198,
   "type": "ground"
  },
  {
   "id": 4199,
   "type": "ground"
  },
  {
   "id": 4200,
   "type": "ground"
  },
  {
   "id": 4201,
   "type": "ground"
  },
  {
   "id": 4202,
   "type": "ground"
  },
  {
   "id": 4203,
   "type": "ground"
  },
  {
   "id": 4204,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4206,
   "type": "ground"
  },
  {
   "id": 4207,
   "type": "ground"
  },
  {
   "id": 4208,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -15,
        "y": 6
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4209,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 15,
        "y": 5
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4210,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -6,
        "y": 8
       },
       {
        "x": -6,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4211,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -8
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4212,
   "type": "ground"
  },
  {
   "id": 4213,
   "type": "ground"
  },
  {
   "id": 4214,
   "type": "ground"
  },
  {
   "id": 4215,
   "type": "ground"
  },
  {
   "id": 4216,
   "type": "ground"
  },
  {
   "id": 4217,
   "type": "ground"
  },
  {
   "id": 4218,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4219,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 3
       },
       {
        "x": 6,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4224,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4225,
   "type": "ground"
  },
  {
   "id": 4226,
   "type": "ground"
  },
  {
   "id": 4227,
   "type": "ground"
  },
  {
   "id": 4228,
   "type": "ground"
  },
  {
   "id": 4229,
   "type": "ground"
  },
  {
   "id": 4230,
   "type": "ground"
  },
  {
   "id": 4231,
   "type": "ground"
  },
  {
   "id": 4232,
   "type": "ground"
  },
  {
   "id": 4233,
   "type": "ground"
  },
  {
   "id": 4234,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4236,
   "type": "ground"
  },
  {
   "id": 4237,
   "type": "ground"
  },
  {
   "id": 4238,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4239,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4240,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -13,
        "y": 10
       },
       {
        "x": -9,
        "y": 9
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -1,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4241,
   "type": "ground"
  },
  {
   "id": 4242,
   "type": "ground"
  },
  {
   "id": 4243,
   "type": "ground"
  },
  {
   "id": 4244,
   "type": "ground"
  },
  {
   "id": 4245,
   "type": "ground"
  },
  {
   "id": 4246,
   "type": "ground"
  },
  {
   "id": 4247,
   "type": "ground"
  },
  {
   "id": 4248,
   "type": "ground"
  },
  {
   "id": 4249,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 4
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 9,
        "y": 9
       },
       {
        "x": 13,
        "y": 10
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4251,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4252,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4255,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4256,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 8
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4258,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4259,
   "type": "ground"
  },
  {
   "id": 4260,
   "type": "ground"
  },
  {
   "id": 4261,
   "type": "ground"
  },
  {
   "id": 4262,
   "type": "ground"
  },
  {
   "id": 4263,
   "type": "ground"
  },
  {
   "id": 4264,
   "type": "ground"
  },
  {
   "id": 4265,
   "type": "ground"
  },
  {
   "id": 4266,
   "type": "ground"
  },
  {
   "id": 4267,
   "type": "ground"
  },
  {
   "id": 4268,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4270,
   "type": "ground"
  },
  {
   "id": 4271,
   "type": "ground"
  },
  {
   "id": 4272,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4273,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4274,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -11,
        "y": 16
       },
       {
        "x": -13,
        "y": 10
       },
       {
        "x": -9,
        "y": 9
       },
       {
        "x": -9,
        "y": 5
       },
       {
        "x": -1,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4275,
   "type": "ground"
  },
  {
   "id": 4276,
   "type": "ground"
  },
  {
   "id": 4277,
   "type": "ground"
  },
  {
   "id": 4278,
   "type": "ground"
  },
  {
   "id": 4279,
   "type": "ground"
  },
  {
   "id": 4280,
   "type": "ground"
  },
  {
   "id": 4281,
   "type": "ground"
  },
  {
   "id": 4282,
   "type": "ground"
  },
  {
   "id": 4283,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 4
       },
       {
        "x": 9,
        "y": 5
       },
       {
        "x": 9,
        "y": 9
       },
       {
        "x": 13,
        "y": 10
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4288,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4289,
   "type": "ground"
  },
  {
   "id": 4290,
   "type": "ground"
  },
  {
   "id": 4291,
   "type": "ground"
  },
  {
   "id": 4292,
   "type": "ground"
  },
  {
   "id": 4293,
   "type": "ground"
  },
  {
   "id": 4294,
   "type": "ground"
  },
  {
   "id": 4295,
   "type": "ground"
  },
  {
   "id": 4296,
   "type": "ground"
  },
  {
   "id": 4297,
   "type": "ground"
  },
  {
   "id": 4298,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4300,
   "type": "ground"
  },
  {
   "id": 4301,
   "type": "ground"
  },
  {
   "id": 4302,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4303,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4304,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4305,
   "type": "ground"
  },
  {
   "id": 4306,
   "type": "ground"
  },
  {
   "id": 4307,
   "type": "ground"
  },
  {
   "id": 4308,
   "type": "ground"
  },
  {
   "id": 4309,
   "type": "ground"
  },
  {
   "id": 4310,
   "type": "ground"
  },
  {
   "id": 4311,
   "type": "ground"
  },
  {
   "id": 4312,
   "type": "ground"
  },
  {
   "id": 4313,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 11,
        "y": 4
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": 4,
        "y": 9
       },
       {
        "x": 11,
        "y": 11
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4315,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4316,
   "type": "ground"
  },
  {
   "id": 4319,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 11,
      "x": 5,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4320,
   "type": "ground"
  },
  {
   "id": 4322,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4323,
   "type": "ground"
  },
  {
   "id": 4324,
   "type": "ground"
  },
  {
   "id": 4325,
   "type": "ground"
  },
  {
   "id": 4326,
   "type": "ground"
  },
  {
   "id": 4327,
   "type": "ground"
  },
  {
   "id": 4328,
   "type": "ground"
  },
  {
   "id": 4329,
   "type": "ground"
  },
  {
   "id": 4330,
   "type": "ground"
  },
  {
   "id": 4331,
   "type": "ground"
  },
  {
   "id": 4332,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4334,
   "type": "ground"
  },
  {
   "id": 4335,
   "type": "ground"
  },
  {
   "id": 4336,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -11,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4337,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4338,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": 8,
        "y": 7
       },
       {
        "x": 0,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4339,
   "type": "ground"
  },
  {
   "id": 4340,
   "type": "ground"
  },
  {
   "id": 4341,
   "type": "ground"
  },
  {
   "id": 4342,
   "type": "ground"
  },
  {
   "id": 4343,
   "type": "ground"
  },
  {
   "id": 4344,
   "type": "ground"
  },
  {
   "id": 4345,
   "type": "ground"
  },
  {
   "id": 4346,
   "type": "ground"
  },
  {
   "id": 4347,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 11,
        "y": 4
       },
       {
        "x": 3,
        "y": 6
       },
       {
        "x": 4,
        "y": 9
       },
       {
        "x": 11,
        "y": 11
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4352,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4353,
   "type": "ground"
  },
  {
   "id": 4354,
   "type": "ground"
  },
  {
   "id": 4355,
   "type": "ground"
  },
  {
   "id": 4356,
   "type": "ground"
  },
  {
   "id": 4357,
   "type": "ground"
  },
  {
   "id": 4358,
   "type": "ground"
  },
  {
   "id": 4359,
   "type": "ground"
  },
  {
   "id": 4360,
   "type": "ground"
  },
  {
   "id": 4361,
   "type": "ground"
  },
  {
   "id": 4362,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 14
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4364,
   "type": "ground"
  },
  {
   "id": 4365,
   "type": "ground"
  },
  {
   "id": 4366,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4367,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4368,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -9,
        "y": 6
       },
       {
        "x": -2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4369,
   "type": "ground"
  },
  {
   "id": 4370,
   "type": "ground"
  },
  {
   "id": 4371,
   "type": "ground"
  },
  {
   "id": 4372,
   "type": "ground"
  },
  {
   "id": 4373,
   "type": "ground"
  },
  {
   "id": 4374,
   "type": "ground"
  },
  {
   "id": 4375,
   "type": "ground"
  },
  {
   "id": 4376,
   "type": "ground"
  },
  {
   "id": 4377,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 4
       },
       {
        "x": 9,
        "y": 6
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4379,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4380,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4383,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": -16
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4384,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4386,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4387,
   "type": "ground"
  },
  {
   "id": 4388,
   "type": "ground"
  },
  {
   "id": 4389,
   "type": "ground"
  },
  {
   "id": 4390,
   "type": "ground"
  },
  {
   "id": 4391,
   "type": "ground"
  },
  {
   "id": 4392,
   "type": "ground"
  },
  {
   "id": 4393,
   "type": "ground"
  },
  {
   "id": 4394,
   "type": "ground"
  },
  {
   "id": 4395,
   "type": "ground"
  },
  {
   "id": 4396,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 14
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4398,
   "type": "ground"
  },
  {
   "id": 4399,
   "type": "ground"
  },
  {
   "id": 4400,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4401,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -13,
        "y": 16
       },
       {
        "x": -13,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4402,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -9,
        "y": 6
       },
       {
        "x": -2,
        "y": 4
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4403,
   "type": "ground"
  },
  {
   "id": 4404,
   "type": "ground"
  },
  {
   "id": 4405,
   "type": "ground"
  },
  {
   "id": 4406,
   "type": "ground"
  },
  {
   "id": 4407,
   "type": "ground"
  },
  {
   "id": 4408,
   "type": "ground"
  },
  {
   "id": 4409,
   "type": "ground"
  },
  {
   "id": 4410,
   "type": "ground"
  },
  {
   "id": 4411,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 4
       },
       {
        "x": 9,
        "y": 6
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4416,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4417,
   "type": "ground"
  },
  {
   "id": 4418,
   "type": "ground"
  },
  {
   "id": 4419,
   "type": "ground"
  },
  {
   "id": 4420,
   "type": "ground"
  },
  {
   "id": 4421,
   "type": "ground"
  },
  {
   "id": 4422,
   "type": "ground"
  },
  {
   "id": 4423,
   "type": "ground"
  },
  {
   "id": 4424,
   "type": "ground"
  },
  {
   "id": 4425,
   "type": "ground"
  },
  {
   "id": 4426,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4428,
   "type": "ground"
  },
  {
   "id": 4429,
   "type": "ground"
  },
  {
   "id": 4430,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4431,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4432,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4433,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -2
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4434,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 10,
        "y": 8
       },
       {
        "x": 10,
        "y": 6
       },
       {
        "x": 1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4435,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 0,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4436,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 10,
        "y": 5
       },
       {
        "x": 11,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4437,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4438,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4439,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 3,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4440,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4441,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 2
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4443,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -14,
        "y": 16
       },
       {
        "x": -12,
        "y": 2
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4444,
   "type": "ground"
  },
  {
   "id": 4445,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 1
       },
       {
        "x": 2,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4446,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 2,
        "y": 0
       },
       {
        "x": 2,
        "y": 8
       },
       {
        "x": -1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4447,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 6,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": -6
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": 10
       },
       {
        "x": 0,
        "y": 10
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4448,
   "type": "ground"
  },
  {
   "id": 4449,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 6
       },
       {
        "x": 2,
        "y": 12
       },
       {
        "x": 2,
        "y": 15
       },
       {
        "x": 0,
        "y": 15
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4450,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4451,
   "type": "ground"
  },
  {
   "id": 4452,
   "type": "ground"
  },
  {
   "id": 4453,
   "type": "ground"
  },
  {
   "id": 4454,
   "type": "ground"
  },
  {
   "id": 4455,
   "type": "ground"
  },
  {
   "id": 4456,
   "type": "ground"
  },
  {
   "id": 4457,
   "type": "ground"
  },
  {
   "id": 4458,
   "type": "ground"
  },
  {
   "id": 4459,
   "type": "ground"
  },
  {
   "id": 4460,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4462,
   "type": "ground"
  },
  {
   "id": 4463,
   "type": "ground"
  },
  {
   "id": 4464,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4465,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 13,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4466,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 6,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4467,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 2,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -2
       },
       {
        "x": 0,
        "y": -2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4468,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 10,
        "y": 8
       },
       {
        "x": 10,
        "y": 6
       },
       {
        "x": 1,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4469,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 0,
        "y": -7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4470,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 10,
        "y": 5
       },
       {
        "x": 11,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4471,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -6
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4472,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4473,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 3,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 3,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4474,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4475,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -7,
        "y": 2
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4480,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4481,
   "type": "ground"
  },
  {
   "id": 4482,
   "type": "ground"
  },
  {
   "id": 4483,
   "type": "ground"
  },
  {
   "id": 4484,
   "type": "ground"
  },
  {
   "id": 4485,
   "type": "ground"
  },
  {
   "id": 4486,
   "type": "ground"
  },
  {
   "id": 4487,
   "type": "ground"
  },
  {
   "id": 4488,
   "type": "ground"
  },
  {
   "id": 4489,
   "type": "ground"
  },
  {
   "id": 4490,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 14
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4492,
   "type": "ground"
  },
  {
   "id": 4493,
   "type": "ground"
  },
  {
   "id": 4494,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4495,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4496,
   "type": "ground"
  },
  {
   "id": 4497,
   "type": "ground"
  },
  {
   "id": 4498,
   "type": "ground"
  },
  {
   "id": 4499,
   "type": "ground"
  },
  {
   "id": 4500,
   "type": "ground"
  },
  {
   "id": 4501,
   "type": "ground"
  },
  {
   "id": 4502,
   "type": "ground"
  },
  {
   "id": 4503,
   "type": "ground"
  },
  {
   "id": 4504,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4505,
   "type": "ground"
  },
  {
   "id": 4507,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -11,
        "y": 15
       },
       {
        "x": -10,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4508,
   "type": "ground"
  },
  {
   "id": 4511,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 1,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 15
       },
       {
        "x": -11,
        "y": 15
       },
       {
        "x": -10,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4512,
   "type": "ground"
  },
  {
   "id": 4514,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4515,
   "type": "ground"
  },
  {
   "id": 4516,
   "type": "ground"
  },
  {
   "id": 4517,
   "type": "ground"
  },
  {
   "id": 4518,
   "type": "ground"
  },
  {
   "id": 4519,
   "type": "ground"
  },
  {
   "id": 4520,
   "type": "ground"
  },
  {
   "id": 4521,
   "type": "ground"
  },
  {
   "id": 4522,
   "type": "ground"
  },
  {
   "id": 4523,
   "type": "ground"
  },
  {
   "id": 4524,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 14
       },
       {
        "x": 7,
        "y": 16
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4526,
   "type": "ground"
  },
  {
   "id": 4527,
   "type": "ground"
  },
  {
   "id": 4528,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4529,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4530,
   "type": "ground"
  },
  {
   "id": 4531,
   "type": "ground"
  },
  {
   "id": 4532,
   "type": "ground"
  },
  {
   "id": 4533,
   "type": "ground"
  },
  {
   "id": 4534,
   "type": "ground"
  },
  {
   "id": 4535,
   "type": "ground"
  },
  {
   "id": 4536,
   "type": "ground"
  },
  {
   "id": 4537,
   "type": "ground"
  },
  {
   "id": 4538,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -9
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4539,
   "type": "ground"
  },
  {
   "id": 4544,
   "type": "ground"
  },
  {
   "id": 4545,
   "type": "ground"
  },
  {
   "id": 4546,
   "type": "ground"
  },
  {
   "id": 4547,
   "type": "ground"
  },
  {
   "id": 4548,
   "type": "ground"
  },
  {
   "id": 4549,
   "type": "ground"
  },
  {
   "id": 4550,
   "type": "ground"
  },
  {
   "id": 4551,
   "type": "ground"
  },
  {
   "id": 4552,
   "type": "ground"
  },
  {
   "id": 4553,
   "type": "ground"
  },
  {
   "id": 4554,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4556,
   "type": "ground"
  },
  {
   "id": 4557,
   "type": "ground"
  },
  {
   "id": 4558,
   "type": "ground"
  },
  {
   "id": 4559,
   "type": "ground"
  },
  {
   "id": 4560,
   "type": "ground"
  },
  {
   "id": 4561,
   "type": "ground"
  },
  {
   "id": 4562,
   "type": "ground"
  },
  {
   "id": 4563,
   "type": "ground"
  },
  {
   "id": 4564,
   "type": "ground"
  },
  {
   "id": 4565,
   "type": "ground"
  },
  {
   "id": 4566,
   "type": "ground"
  },
  {
   "id": 4567,
   "type": "ground"
  },
  {
   "id": 4568,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4569,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4571,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4572,
   "type": "ground"
  },
  {
   "id": 4575,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 5,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 0
       },
       {
        "x": 11,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4576,
   "type": "ground"
  },
  {
   "id": 4578,
   "type": "ground"
  },
  {
   "id": 4579,
   "type": "ground"
  },
  {
   "id": 4580,
   "type": "ground"
  },
  {
   "id": 4581,
   "type": "ground"
  },
  {
   "id": 4582,
   "type": "ground"
  },
  {
   "id": 4583,
   "type": "ground"
  },
  {
   "id": 4584,
   "type": "ground"
  },
  {
   "id": 4585,
   "type": "ground"
  },
  {
   "id": 4586,
   "type": "ground"
  },
  {
   "id": 4587,
   "type": "ground"
  },
  {
   "id": 4588,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4590,
   "type": "ground"
  },
  {
   "id": 4591,
   "type": "ground"
  },
  {
   "id": 4592,
   "type": "ground"
  },
  {
   "id": 4593,
   "type": "ground"
  },
  {
   "id": 4594,
   "type": "ground"
  },
  {
   "id": 4595,
   "type": "ground"
  },
  {
   "id": 4596,
   "type": "ground"
  },
  {
   "id": 4597,
   "type": "ground"
  },
  {
   "id": 4598,
   "type": "ground"
  },
  {
   "id": 4599,
   "type": "ground"
  },
  {
   "id": 4600,
   "type": "ground"
  },
  {
   "id": 4601,
   "type": "ground"
  },
  {
   "id": 4602,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4603,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 13,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -13
       },
       {
        "x": 16,
        "y": 3
       },
       {
        "x": 0,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4608,
   "type": "ground"
  },
  {
   "id": 4609,
   "type": "ground"
  },
  {
   "id": 4610,
   "type": "ground"
  },
  {
   "id": 4611,
   "type": "ground"
  },
  {
   "id": 4612,
   "type": "ground"
  },
  {
   "id": 4613,
   "type": "ground"
  },
  {
   "id": 4614,
   "type": "ground"
  },
  {
   "id": 4615,
   "type": "ground"
  },
  {
   "id": 4616,
   "type": "ground"
  },
  {
   "id": 4617,
   "type": "ground"
  },
  {
   "id": 4618,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4620,
   "type": "ground"
  },
  {
   "id": 4621,
   "type": "ground"
  },
  {
   "id": 4622,
   "type": "ground"
  },
  {
   "id": 4623,
   "type": "ground"
  },
  {
   "id": 4624,
   "type": "ground"
  },
  {
   "id": 4625,
   "type": "ground"
  },
  {
   "id": 4626,
   "type": "ground"
  },
  {
   "id": 4627,
   "type": "ground"
  },
  {
   "id": 4628,
   "type": "ground"
  },
  {
   "id": 4629,
   "type": "ground"
  },
  {
   "id": 4630,
   "type": "ground"
  },
  {
   "id": 4631,
   "type": "ground"
  },
  {
   "id": 4632,
   "type": "ground"
  },
  {
   "id": 4633,
   "type": "ground"
  },
  {
   "id": 4635,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -16
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4636,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4639,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -16
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4640,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4642,
   "type": "ground"
  },
  {
   "id": 4643,
   "type": "ground"
  },
  {
   "id": 4644,
   "type": "ground"
  },
  {
   "id": 4645,
   "type": "ground"
  },
  {
   "id": 4646,
   "type": "ground"
  },
  {
   "id": 4647,
   "type": "ground"
  },
  {
   "id": 4648,
   "type": "ground"
  },
  {
   "id": 4649,
   "type": "ground"
  },
  {
   "id": 4650,
   "type": "ground"
  },
  {
   "id": 4651,
   "type": "ground"
  },
  {
   "id": 4652,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 3,
        "y": 5
       },
       {
        "x": 6,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4654,
   "type": "ground"
  },
  {
   "id": 4655,
   "type": "ground"
  },
  {
   "id": 4656,
   "type": "ground"
  },
  {
   "id": 4657,
   "type": "ground"
  },
  {
   "id": 4658,
   "type": "ground"
  },
  {
   "id": 4659,
   "type": "ground"
  },
  {
   "id": 4660,
   "type": "ground"
  },
  {
   "id": 4661,
   "type": "ground"
  },
  {
   "id": 4662,
   "type": "ground"
  },
  {
   "id": 4663,
   "type": "ground"
  },
  {
   "id": 4664,
   "type": "ground"
  },
  {
   "id": 4665,
   "type": "ground"
  },
  {
   "id": 4666,
   "type": "ground"
  },
  {
   "id": 4667,
   "type": "ground"
  },
  {
   "id": 4672,
   "type": "ground"
  },
  {
   "id": 4673,
   "type": "ground"
  },
  {
   "id": 4674,
   "type": "ground"
  },
  {
   "id": 4675,
   "type": "ground"
  },
  {
   "id": 4676,
   "type": "ground"
  },
  {
   "id": 4677,
   "type": "ground"
  },
  {
   "id": 4678,
   "type": "ground"
  },
  {
   "id": 4679,
   "type": "ground"
  },
  {
   "id": 4680,
   "type": "ground"
  },
  {
   "id": 4681,
   "type": "ground"
  },
  {
   "id": 4682,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4684,
   "type": "ground"
  },
  {
   "id": 4685,
   "type": "ground"
  },
  {
   "id": 4686,
   "type": "ground"
  },
  {
   "id": 4687,
   "type": "ground"
  },
  {
   "id": 4688,
   "type": "ground"
  },
  {
   "id": 4689,
   "type": "ground"
  },
  {
   "id": 4690,
   "type": "ground"
  },
  {
   "id": 4691,
   "type": "ground"
  },
  {
   "id": 4692,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 2
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4693,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 8
       },
       {
        "x": -11,
        "y": 7
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4694,
   "type": "ground"
  },
  {
   "id": 4695,
   "type": "ground"
  },
  {
   "id": 4696,
   "type": "ground"
  },
  {
   "id": 4697,
   "type": "ground"
  },
  {
   "id": 4699,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -16
       },
       {
        "x": 12,
        "y": -16
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4700,
   "type": "ground"
  },
  {
   "id": 4703,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": -16
       },
       {
        "x": 12,
        "y": -16
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4704,
   "type": "ground"
  },
  {
   "id": 4706,
   "type": "ground"
  },
  {
   "id": 4707,
   "type": "ground"
  },
  {
   "id": 4708,
   "type": "ground"
  },
  {
   "id": 4709,
   "type": "ground"
  },
  {
   "id": 4710,
   "type": "ground"
  },
  {
   "id": 4711,
   "type": "ground"
  },
  {
   "id": 4712,
   "type": "ground"
  },
  {
   "id": 4713,
   "type": "ground"
  },
  {
   "id": 4714,
   "type": "ground"
  },
  {
   "id": 4715,
   "type": "ground"
  },
  {
   "id": 4716,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 5
       },
       {
        "x": -3,
        "y": 6
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -6,
        "y": 16
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4718,
   "type": "ground"
  },
  {
   "id": 4719,
   "type": "ground"
  },
  {
   "id": 4720,
   "type": "ground"
  },
  {
   "id": 4721,
   "type": "ground"
  },
  {
   "id": 4722,
   "type": "ground"
  },
  {
   "id": 4723,
   "type": "ground"
  },
  {
   "id": 4724,
   "type": "ground"
  },
  {
   "id": 4725,
   "type": "ground"
  },
  {
   "id": 4726,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 10,
        "y": 2
       },
       {
        "x": 11,
        "y": 6
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4727,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 8
       },
       {
        "x": -11,
        "y": 7
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4728,
   "type": "ground"
  },
  {
   "id": 4729,
   "type": "ground"
  },
  {
   "id": 4730,
   "type": "ground"
  },
  {
   "id": 4731,
   "type": "ground"
  },
  {
   "id": 4736,
   "type": "ground"
  },
  {
   "id": 4737,
   "type": "ground"
  },
  {
   "id": 4738,
   "type": "ground"
  },
  {
   "id": 4739,
   "type": "ground"
  },
  {
   "id": 4740,
   "type": "ground"
  },
  {
   "id": 4741,
   "type": "ground"
  },
  {
   "id": 4742,
   "type": "ground"
  },
  {
   "id": 4743,
   "type": "ground"
  },
  {
   "id": 4744,
   "type": "ground"
  },
  {
   "id": 4745,
   "type": "ground"
  },
  {
   "id": 4746,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4748,
   "type": "ground"
  },
  {
   "id": 4749,
   "type": "ground"
  },
  {
   "id": 4750,
   "type": "ground"
  },
  {
   "id": 4751,
   "type": "ground"
  },
  {
   "id": 4752,
   "type": "ground"
  },
  {
   "id": 4753,
   "type": "ground"
  },
  {
   "id": 4754,
   "type": "ground"
  },
  {
   "id": 4755,
   "type": "ground"
  },
  {
   "id": 4758,
   "type": "ground"
  },
  {
   "id": 4759,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 3,
        "y": 10
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4760,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -10,
        "y": 10
       },
       {
        "x": -12,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4761,
   "type": "ground"
  },
  {
   "id": 4763,
   "type": "ground"
  },
  {
   "id": 4764,
   "type": "ground"
  },
  {
   "id": 4767,
   "type": "ground"
  },
  {
   "id": 4768,
   "type": "ground"
  },
  {
   "id": 4770,
   "type": "ground"
  },
  {
   "id": 4771,
   "type": "ground"
  },
  {
   "id": 4772,
   "type": "ground"
  },
  {
   "id": 4773,
   "type": "ground"
  },
  {
   "id": 4774,
   "type": "ground"
  },
  {
   "id": 4775,
   "type": "ground"
  },
  {
   "id": 4776,
   "type": "ground"
  },
  {
   "id": 4777,
   "type": "ground"
  },
  {
   "id": 4778,
   "type": "ground"
  },
  {
   "id": 4779,
   "type": "ground"
  },
  {
   "id": 4780,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4782,
   "type": "ground"
  },
  {
   "id": 4783,
   "type": "ground"
  },
  {
   "id": 4784,
   "type": "ground"
  },
  {
   "id": 4785,
   "type": "ground"
  },
  {
   "id": 4786,
   "type": "ground"
  },
  {
   "id": 4787,
   "type": "ground"
  },
  {
   "id": 4788,
   "type": "ground"
  },
  {
   "id": 4789,
   "type": "ground"
  },
  {
   "id": 4792,
   "type": "ground"
  },
  {
   "id": 4793,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 3,
        "y": 10
       },
       {
        "x": 14,
        "y": 11
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4794,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -10,
        "y": 10
       },
       {
        "x": -12,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4795,
   "type": "ground"
  },
  {
   "id": 4800,
   "type": "ground"
  },
  {
   "id": 4801,
   "type": "ground"
  },
  {
   "id": 4802,
   "type": "ground"
  },
  {
   "id": 4803,
   "type": "ground"
  },
  {
   "id": 4804,
   "type": "ground"
  },
  {
   "id": 4805,
   "type": "ground"
  },
  {
   "id": 4806,
   "type": "ground"
  },
  {
   "id": 4807,
   "type": "ground"
  },
  {
   "id": 4808,
   "type": "ground"
  },
  {
   "id": 4809,
   "type": "ground"
  },
  {
   "id": 4810,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4812,
   "type": "ground"
  },
  {
   "id": 4813,
   "type": "ground"
  },
  {
   "id": 4814,
   "type": "ground"
  },
  {
   "id": 4815,
   "type": "ground"
  },
  {
   "id": 4816,
   "type": "ground"
  },
  {
   "id": 4817,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 2
       },
       {
        "x": -2,
        "y": 10
       },
       {
        "x": -7,
        "y": 13
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4818,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4819,
   "type": "ground"
  },
  {
   "id": 4822,
   "type": "ground"
  },
  {
   "id": 4823,
   "type": "ground"
  },
  {
   "id": 4824,
   "type": "ground"
  },
  {
   "id": 4825,
   "type": "ground"
  },
  {
   "id": 4827,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4828,
   "type": "ground"
  },
  {
   "id": 4831,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4832,
   "type": "ground"
  },
  {
   "id": 4834,
   "type": "ground"
  },
  {
   "id": 4835,
   "type": "ground"
  },
  {
   "id": 4836,
   "type": "ground"
  },
  {
   "id": 4837,
   "type": "ground"
  },
  {
   "id": 4838,
   "type": "ground"
  },
  {
   "id": 4839,
   "type": "ground"
  },
  {
   "id": 4840,
   "type": "ground"
  },
  {
   "id": 4841,
   "type": "ground"
  },
  {
   "id": 4842,
   "type": "ground"
  },
  {
   "id": 4843,
   "type": "ground"
  },
  {
   "id": 4844,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 12,
        "y": 16
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -4,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4846,
   "type": "ground"
  },
  {
   "id": 4847,
   "type": "ground"
  },
  {
   "id": 4848,
   "type": "ground"
  },
  {
   "id": 4849,
   "type": "ground"
  },
  {
   "id": 4850,
   "type": "ground"
  },
  {
   "id": 4851,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 10,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 2
       },
       {
        "x": -2,
        "y": 10
       },
       {
        "x": -7,
        "y": 13
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -10,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4852,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4853,
   "type": "ground"
  },
  {
   "id": 4856,
   "type": "ground"
  },
  {
   "id": 4857,
   "type": "ground"
  },
  {
   "id": 4858,
   "type": "ground"
  },
  {
   "id": 4859,
   "type": "ground"
  },
  {
   "id": 4864,
   "type": "ground"
  },
  {
   "id": 4865,
   "type": "ground"
  },
  {
   "id": 4866,
   "type": "ground"
  },
  {
   "id": 4867,
   "type": "ground"
  },
  {
   "id": 4868,
   "type": "ground"
  },
  {
   "id": 4869,
   "type": "ground"
  },
  {
   "id": 4870,
   "type": "ground"
  },
  {
   "id": 4871,
   "type": "ground"
  },
  {
   "id": 4872,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4873,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4874,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -15,
        "y": 13
       },
       {
        "x": -6,
        "y": 12
       },
       {
        "x": -10,
        "y": 5
       },
       {
        "x": -7,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4875,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4876,
   "type": "ground"
  },
  {
   "id": 4877,
   "type": "ground"
  },
  {
   "id": 4878,
   "type": "ground"
  },
  {
   "id": 4879,
   "type": "ground"
  },
  {
   "id": 4880,
   "type": "ground"
  },
  {
   "id": 4881,
   "type": "ground"
  },
  {
   "id": 4882,
   "type": "ground"
  },
  {
   "id": 4883,
   "type": "ground"
  },
  {
   "id": 4884,
   "type": "ground"
  },
  {
   "id": 4885,
   "type": "ground"
  },
  {
   "id": 4887,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -4,
        "y": 13
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -10,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4888,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 10,
        "y": 16
       },
       {
        "x": 4,
        "y": 16
       },
       {
        "x": 4,
        "y": 13
       },
       {
        "x": 0,
        "y": 11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4891,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4892,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4895,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4896,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 16,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 4898,
   "type": "ground"
  },
  {
   "id": 4899,
   "type": "ground"
  },
  {
   "id": 4900,
   "type": "ground"
  },
  {
   "id": 4901,
   "type": "ground"
  },
  {
   "id": 4902,
   "type": "ground"
  },
  {
   "id": 4903,
   "type": "ground"
  },
  {
   "id": 4904,
   "type": "ground"
  },
  {
   "id": 4905,
   "type": "ground"
  },
  {
   "id": 4906,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4907,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 0,
        "y": 8
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4908,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -15,
        "y": 13
       },
       {
        "x": -6,
        "y": 12
       },
       {
        "x": -10,
        "y": 5
       },
       {
        "x": -7,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4909,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 11
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4910,
   "type": "ground"
  },
  {
   "id": 4911,
   "type": "ground"
  },
  {
   "id": 4912,
   "type": "ground"
  },
  {
   "id": 4913,
   "type": "ground"
  },
  {
   "id": 4914,
   "type": "ground"
  },
  {
   "id": 4915,
   "type": "ground"
  },
  {
   "id": 4928,
   "type": "ground"
  },
  {
   "id": 4929,
   "type": "ground"
  },
  {
   "id": 4930,
   "type": "ground"
  },
  {
   "id": 4931,
   "type": "ground"
  },
  {
   "id": 4932,
   "type": "ground"
  },
  {
   "id": 4933,
   "type": "ground"
  },
  {
   "id": 4934,
   "type": "ground"
  },
  {
   "id": 4935,
   "type": "ground"
  },
  {
   "id": 4936,
   "type": "ground"
  },
  {
   "id": 4937,
   "type": "ground"
  },
  {
   "id": 4938,
   "type": "ground"
  },
  {
   "id": 4939,
   "type": "ground"
  },
  {
   "id": 4940,
   "type": "ground"
  },
  {
   "id": 4941,
   "type": "ground"
  },
  {
   "id": 4942,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4943,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4944,
   "type": "ground"
  },
  {
   "id": 4945,
   "type": "ground"
  },
  {
   "id": 4946,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 12,
        "y": 2
       },
       {
        "x": 1,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4947,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 2
       },
       {
        "x": -12,
        "y": 2
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4948,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 12,
        "y": 2
       },
       {
        "x": 1,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4949,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 2
       },
       {
        "x": -12,
        "y": 2
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4951,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 6,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 5,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4952,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 4,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 6,
        "y": 0
       },
       {
        "x": 5,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4955,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -16
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4956,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 13
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4959,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 9,
        "y": -16
       },
       {
        "x": 9,
        "y": 0
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4960,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 13
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4962,
   "type": "ground"
  },
  {
   "id": 4963,
   "type": "ground"
  },
  {
   "id": 4964,
   "type": "ground"
  },
  {
   "id": 4965,
   "type": "ground"
  },
  {
   "id": 4966,
   "type": "ground"
  },
  {
   "id": 4967,
   "type": "ground"
  },
  {
   "id": 4968,
   "type": "ground"
  },
  {
   "id": 4969,
   "type": "ground"
  },
  {
   "id": 4970,
   "type": "ground"
  },
  {
   "id": 4971,
   "type": "ground"
  },
  {
   "id": 4972,
   "type": "ground"
  },
  {
   "id": 4973,
   "type": "ground"
  },
  {
   "id": 4974,
   "type": "ground"
  },
  {
   "id": 4975,
   "type": "ground"
  },
  {
   "id": 4976,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 16,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 16,
        "y": -16
       },
       {
        "x": 0,
        "y": -16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4977,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 5,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": -5
       },
       {
        "x": 0,
        "y": -5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 4978,
   "type": "ground"
  },
  {
   "id": 4979,
   "type": "ground"
  },
  {
   "id": 4992,
   "type": "ground"
  },
  {
   "id": 4993,
   "type": "ground"
  },
  {
   "id": 4994,
   "type": "ground"
  },
  {
   "id": 4995,
   "type": "ground"
  },
  {
   "id": 4996,
   "type": "ground"
  },
  {
   "id": 4997,
   "type": "ground"
  },
  {
   "id": 4998,
   "type": "ground"
  },
  {
   "id": 4999,
   "type": "ground"
  },
  {
   "id": 5000,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 5
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5001,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5002,
   "type": "ground"
  },
  {
   "id": 5003,
   "type": "ground"
  },
  {
   "id": 5004,
   "type": "ground"
  },
  {
   "id": 5005,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5008,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5009,
   "type": "ground"
  },
  {
   "id": 5010,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 15,
        "y": 6
       },
       {
        "x": 12,
        "y": 7
       },
       {
        "x": 16,
        "y": 8
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 4,
        "y": 14
       },
       {
        "x": 4,
        "y": 7
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5011,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 1
       },
       {
        "x": 3,
        "y": 7
       },
       {
        "x": 0,
        "y": 7
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5014,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 7
       },
       {
        "x": -3,
        "y": 7
       },
       {
        "x": -3,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5015,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -4,
        "y": 7
       },
       {
        "x": -4,
        "y": 14
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 8
       },
       {
        "x": -12,
        "y": 7
       },
       {
        "x": -15,
        "y": 6
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5019,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -11
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5020,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 1
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5023,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": -11
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 16,
        "y": 5
       },
       {
        "x": 0,
        "y": 5
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5024,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 11,
        "y": 1
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5026,
   "type": "ground"
  },
  {
   "id": 5027,
   "type": "ground"
  },
  {
   "id": 5028,
   "type": "ground"
  },
  {
   "id": 5029,
   "type": "ground"
  },
  {
   "id": 5030,
   "type": "ground"
  },
  {
   "id": 5031,
   "type": "ground"
  },
  {
   "id": 5032,
   "type": "ground"
  },
  {
   "id": 5033,
   "type": "ground"
  },
  {
   "id": 5034,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 13,
        "y": 0
       },
       {
        "x": 12,
        "y": 5
       },
       {
        "x": 16,
        "y": 7
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5035,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 7,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -7
       },
       {
        "x": 16,
        "y": 9
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5036,
   "type": "ground"
  },
  {
   "id": 5037,
   "type": "ground"
  },
  {
   "id": 5038,
   "type": "ground"
  },
  {
   "id": 5039,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -4,
        "y": 16
       },
       {
        "x": -16,
        "y": 16
       },
       {
        "x": -16,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5042,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 2,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 14,
        "y": 0
       },
       {
        "x": 14,
        "y": 16
       },
       {
        "x": 6,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5043,
   "type": "ground"
  },
  {
   "id": 5056,
   "type": "ground"
  },
  {
   "id": 5057,
   "type": "ground"
  },
  {
   "id": 5058,
   "type": "ground"
  },
  {
   "id": 5059,
   "type": "ground"
  },
  {
   "id": 5060,
   "type": "ground"
  },
  {
   "id": 5061,
   "type": "ground"
  },
  {
   "id": 5062,
   "type": "ground"
  },
  {
   "id": 5063,
   "type": "ground"
  },
  {
   "id": 5064,
   "type": "ground"
  },
  {
   "id": 5065,
   "type": "ground"
  },
  {
   "id": 5066,
   "type": "ground"
  },
  {
   "id": 5067,
   "type": "ground"
  },
  {
   "id": 5068,
   "type": "ground"
  },
  {
   "id": 5069,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5072,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5073,
   "type": "ground"
  },
  {
   "id": 5074,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 15
       },
       {
        "x": 4,
        "y": 15
       },
       {
        "x": 4,
        "y": 7
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5075,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 1
       },
       {
        "x": 7,
        "y": 6
       },
       {
        "x": 4,
        "y": 7
       },
       {
        "x": 11,
        "y": 9
       },
       {
        "x": 11,
        "y": 14
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5078,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 16
       },
       {
        "x": -8,
        "y": 16
       },
       {
        "x": -11,
        "y": 14
       },
       {
        "x": -11,
        "y": 9
       },
       {
        "x": -4,
        "y": 7
       },
       {
        "x": -7,
        "y": 6
       },
       {
        "x": -6,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5079,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -4,
        "y": 7
       },
       {
        "x": -4,
        "y": 15
       },
       {
        "x": -8,
        "y": 15
       },
       {
        "x": -8,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5082,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": -2,
        "y": 9
       },
       {
        "x": -2,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5083,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 9,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 5084,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 9,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 14,
      "x": 0,
      "y": 0
     }
    ]
   }
  },
  {
   "id": 5086,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 11
       },
       {
        "x": -6,
        "y": 11
       },
       {
        "x": -9,
        "y": 7
       },
       {
        "x": -8,
        "y": 3
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5087,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 11,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 1
       },
       {
        "x": 16,
        "y": -11
       },
       {
        "x": 0,
        "y": -11
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5088,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 14,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 8
       },
       {
        "x": -2,
        "y": 10
       },
       {
        "x": -14,
        "y": 12
       },
       {
        "x": -14,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5090,
   "type": "ground"
  },
  {
   "id": 5091,
   "type": "ground"
  },
  {
   "id": 5092,
   "type": "ground"
  },
  {
   "id": 5093,
   "type": "ground"
  },
  {
   "id": 5094,
   "type": "ground"
  },
  {
   "id": 5095,
   "type": "ground"
  },
  {
   "id": 5096,
   "type": "ground"
  },
  {
   "id": 5097,
   "type": "ground"
  },
  {
   "id": 5098,
   "type": "ground"
  },
  {
   "id": 5099,
   "type": "ground"
  },
  {
   "id": 5100,
   "type": "ground"
  },
  {
   "id": 5101,
   "type": "ground"
  },
  {
   "id": 5102,
   "type": "ground"
  },
  {
   "id": 5103,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 12,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -3,
        "y": 16
       },
       {
        "x": -12,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5106,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 8,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 0
       },
       {
        "x": 8,
        "y": 16
       },
       {
        "x": 3,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5107,
   "type": "ground"
  },
  {
   "id": 5120,
   "type": "ground"
  },
  {
   "id": 5121,
   "type": "ground"
  },
  {
   "id": 5122,
   "type": "ground"
  },
  {
   "id": 5123,
   "type": "ground"
  },
  {
   "id": 5124,
   "type": "ground"
  },
  {
   "id": 5125,
   "type": "ground"
  },
  {
   "id": 5126,
   "type": "ground"
  },
  {
   "id": 5127,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 0,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5128,
   "type": "ground"
  },
  {
   "id": 5129,
   "type": "ground"
  },
  {
   "id": 5130,
   "type": "ground"
  },
  {
   "id": 5131,
   "type": "ground"
  },
  {
   "id": 5132,
   "type": "ground"
  },
  {
   "id": 5133,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5136,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5137,
   "type": "ground"
  },
  {
   "id": 5139,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 1,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 1
       },
       {
        "x": 15,
        "y": 7
       },
       {
        "x": 12,
        "y": 7
       },
       {
        "x": 15,
        "y": 8
       },
       {
        "x": 15,
        "y": 16
       },
       {
        "x": 4,
        "y": 14
       },
       {
        "x": 4,
        "y": 7
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5140,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 3,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 1,
        "y": 6
       },
       {
        "x": -3,
        "y": 8
       },
       {
        "x": -3,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5141,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 8,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 8
       },
       {
        "x": -1,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5142,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 15,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -4,
        "y": 7
       },
       {
        "x": -4,
        "y": 14
       },
       {
        "x": -15,
        "y": 16
       },
       {
        "x": -15,
        "y": 8
       },
       {
        "x": -12,
        "y": 7
       },
       {
        "x": -15,
        "y": 6
       },
       {
        "x": -15,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5144,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 2
       },
       {
        "x": -16,
        "y": 2
       },
       {
        "x": -15,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5145,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 14,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 15,
        "y": 0
       },
       {
        "x": 16,
        "y": 2
       },
       {
        "x": 0,
        "y": 2
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5146,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 2,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 14
     }
    ]
   }
  },
  {
   "id": 5147,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 2,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 16,
      "x": 0,
      "y": 14
     }
    ]
   }
  },
  {
   "id": 5149,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 2,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 4,
      "y": 14
     }
    ]
   }
  },
  {
   "id": 5150,
   "type": "platform",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 2,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 12,
      "x": 0,
      "y": 14
     }
    ]
   }
  },
  {
   "id": 5154,
   "type": "ground"
  },
  {
   "id": 5155,
   "type": "ground"
  },
  {
   "id": 5156,
   "type": "ground"
  },
  {
   "id": 5157,
   "type": "ground"
  },
  {
   "id": 5158,
   "type": "ground"
  },
  {
   "id": 5159,
   "type": "ground"
  },
  {
   "id": 5160,
   "type": "ground"
  },
  {
   "id": 5161,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 0
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 0,
        "y": 13
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5162,
   "type": "ground"
  },
  {
   "id": 5163,
   "type": "ground"
  },
  {
   "id": 5164,
   "type": "ground"
  },
  {
   "id": 5165,
   "type": "ground"
  },
  {
   "id": 5166,
   "type": "ground"
  },
  {
   "id": 5167,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -2,
        "y": 16
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -9,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5170,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 11,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 5,
        "y": 0
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 2,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5171,
   "type": "ground"
  },
  {
   "id": 5174,
   "type": "ground"
  },
  {
   "id": 5175,
   "type": "ground"
  },
  {
   "id": 5178,
   "type": "ground"
  },
  {
   "id": 5179,
   "type": "ground"
  },
  {
   "id": 5184,
   "type": "ground"
  },
  {
   "id": 5185,
   "type": "ground"
  },
  {
   "id": 5186,
   "type": "ground"
  },
  {
   "id": 5187,
   "type": "ground"
  },
  {
   "id": 5188,
   "type": "ground"
  },
  {
   "id": 5189,
   "type": "ground"
  },
  {
   "id": 5190,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 4
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5191,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -4
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5192,
   "type": "ground"
  },
  {
   "id": 5193,
   "type": "ground"
  },
  {
   "id": 5194,
   "type": "ground"
  },
  {
   "id": 5195,
   "type": "ground"
  },
  {
   "id": 5196,
   "type": "ground"
  },
  {
   "id": 5197,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5200,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5201,
   "type": "ground"
  },
  {
   "id": 5203,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 9,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 7,
        "y": 0
       },
       {
        "x": 7,
        "y": 15
       },
       {
        "x": 4,
        "y": 15
       },
       {
        "x": 4,
        "y": 7
       },
       {
        "x": 0,
        "y": 6
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5204,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 8,
        "y": 1
       },
       {
        "x": 8,
        "y": 6
       },
       {
        "x": 5,
        "y": 7
       },
       {
        "x": 11,
        "y": 8
       },
       {
        "x": 12,
        "y": 14
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5205,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -12,
        "y": 14
       },
       {
        "x": -12,
        "y": 9
       },
       {
        "x": -5,
        "y": 7
       },
       {
        "x": -8,
        "y": 6
       },
       {
        "x": -8,
        "y": 1
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5206,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 6
       },
       {
        "x": -4,
        "y": 7
       },
       {
        "x": -4,
        "y": 15
       },
       {
        "x": -7,
        "y": 15
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5208,
   "type": "ground"
  },
  {
   "id": 5209,
   "type": "ground"
  },
  {
   "id": 5210,
   "type": "ground"
  },
  {
   "id": 5211,
   "type": "ground"
  },
  {
   "id": 5213,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 16,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 0,
        "y": 9
       },
       {
        "x": -4,
        "y": 11
       },
       {
        "x": -5,
        "y": 16
       },
       {
        "x": -9,
        "y": 16
       },
       {
        "x": -12,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5214,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 12,
        "y": 0
       },
       {
        "x": 9,
        "y": 16
       },
       {
        "x": 5,
        "y": 16
       },
       {
        "x": 4,
        "y": 11
       },
       {
        "x": 0,
        "y": 9
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5218,
   "type": "ground"
  },
  {
   "id": 5219,
   "type": "ground"
  },
  {
   "id": 5220,
   "type": "ground"
  },
  {
   "id": 5221,
   "type": "ground"
  },
  {
   "id": 5222,
   "type": "ground"
  },
  {
   "id": 5223,
   "type": "ground"
  },
  {
   "id": 5224,
   "type": "slopediagright",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": 4
       },
       {
        "x": 16,
        "y": 16
       },
       {
        "x": 0,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5225,
   "type": "slopediagleft",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 0,
      "y": 4,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 16,
        "y": -4
       },
       {
        "x": 16,
        "y": 12
       },
       {
        "x": 0,
        "y": 12
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5226,
   "type": "ground"
  },
  {
   "id": 5227,
   "type": "ground"
  },
  {
   "id": 5228,
   "type": "ground"
  },
  {
   "id": 5229,
   "type": "ground"
  },
  {
   "id": 5230,
   "type": "ground"
  },
  {
   "id": 5231,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 7,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": -1,
        "y": 16
       },
       {
        "x": -7,
        "y": 16
       },
       {
        "x": -7,
        "y": 0
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5234,
   "type": "ground",
   "objectgroup": {
    "draworder": "index",
    "name": "",
    "opacity": 1,
    "type": "objectgroup",
    "visible": true,
    "x": 0,
    "y": 0,
    "objects": [
     {
      "height": 0,
      "id": 1,
      "name": "",
      "rotation": 0,
      "type": "",
      "visible": true,
      "width": 0,
      "x": 13,
      "y": 0,
      "polygon": [
       {
        "x": 0,
        "y": 0
       },
       {
        "x": 3,
        "y": 0
       },
       {
        "x": 3,
        "y": 16
       },
       {
        "x": 1,
        "y": 16
       }
      ]
     }
    ]
   }
  },
  {
   "id": 5235,
   "type": "ground"
  },
  {
   "id": 5238,
   "type": "ground"
  },
  {
   "id": 5239,
   "type": "ground"
  },
  {
   "id": 5242,
   "type": "ground"
  },
  {
   "id": 5243,
   "type": "ground"
  }
 ],
 "tilewidth": 16,
 "type": "tileset",
 "version": "1.10"
};